(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired124"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired124"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k2ek2", function(module, exports) {
/**
 * A higher order function to debounce a function execution
 * @param  integer  delay    Required - how long to "hold" the function for
 * @param  function callback Required - the function to be called at the end of the delay period
 * @return function
 */ module.exports = function(delay, callback) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            callback.apply(context, args);
        }, delay);
    };
};

});

parcelRegister("70P4J", function(module, exports) {
/**
 * Create a dom element
 * @param  string elementType Required - The type of element to create
 * @param  object attributes  Optional - A list of attribute to add to the element
 * @param  string textNode    Optional - Any text to add to the element
 * @return object Element
 */ 
var $haqKc = parcelRequire("haqKc");
module.exports = function(elementType, attributes, textNode) {
    var element = document.createElement(elementType);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        //
        for(var _iterator = Object.entries(attributes || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $haqKc._)(_step.value, 2), attributeName = _step_value[0], attributeValue = _step_value[1];
            if (attributeName in element) element[attributeName] = attributeValue;
            else element.setAttribute(attributeName, attributeValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    //
    if (typeof textNode !== "undefined") element.append(document.createTextNode(textNode));
    //
    return element;
};

});
parcelRegister("haqKc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c7f81dae783d026c$export$fdf2a89c76341bbf; });

var $kAoWz = parcelRequire("kAoWz");

var $51zgv = parcelRequire("51zgv");

var $8w5yq = parcelRequire("8w5yq");

var $8YVFh = parcelRequire("8YVFh");
function $c7f81dae783d026c$export$fdf2a89c76341bbf(arr, i) {
    return (0, $kAoWz._array_with_holes)(arr) || (0, $51zgv._iterable_to_array_limit)(arr, i) || (0, $8YVFh._unsupported_iterable_to_array)(arr, i) || (0, $8w5yq._non_iterable_rest)();
}

});
parcelRegister("kAoWz", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $efca84b713134a66$export$e6256bf45c68d561; });
function $efca84b713134a66$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("51zgv", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $3a8866aa092b1ebb$export$2fd15edff6687200; });
function $3a8866aa092b1ebb$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("8w5yq", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $63359ed8917f3ec8$export$60dbc22abd7da546; });
function $63359ed8917f3ec8$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("8YVFh", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $68a0a85bb5bfa568$export$a5be06335b3a083c; });

var $822BU = parcelRequire("822BU");
function $68a0a85bb5bfa568$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $822BU._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $822BU._array_like_to_array)(o, minLen);
}

});
parcelRegister("822BU", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $5d9088fdefde415d$export$79e617b1955a2616; });
function $5d9088fdefde415d$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});




parcelRegister("8j5OG", function(module, exports) {
/**
 * Remove all child nodes from an element - https://stackoverflow.com/questions/3955229/remove-all-child-elements-of-a-dom-node-in-javascript
 * @param  HTMLElement element Required - the element that all child nodes need to be removed from
 */ module.exports = function(element) {
    while(element.firstChild)element.removeChild(element.lastChild);
};

});

parcelRegister("kbC9w", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $eb226e0a688f5e68$export$3988ae62b71be9a3; }, function (v) { return $eb226e0a688f5e68$export$3988ae62b71be9a3 = v; });
$parcel$export(module.exports, "set", function () { return $eb226e0a688f5e68$export$adaa4cf7ef1b65be; }, function (v) { return $eb226e0a688f5e68$export$adaa4cf7ef1b65be = v; });
/**
 * Get a value from the current page's session storage
 * @param  {[type]} key          [description]
 * @param  {[type]} defaultValue [description]
 * @return {[type]}              [description]
 */ var $eb226e0a688f5e68$export$3988ae62b71be9a3;
/**
 * Set a value from the current page's session storage
 * @param  {[type]} key   [description]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */ var $eb226e0a688f5e68$export$adaa4cf7ef1b65be;
/**
 * Remove a value from the current page's session storage
 * @param  {[type]} key [description]
 * @return {[type]}     [description]
 */ var $eb226e0a688f5e68$export$cd7f480d6b8286c3;
$eb226e0a688f5e68$export$3988ae62b71be9a3 = function(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    //
    var value = window.sessionStorage.getItem(key);
    //
    if (!value || value === "null") return null;
    //
    try {
        return JSON.parse(value);
    } catch (e) {
        console.log(e);
    }
    //
    return defaultValue;
};
$eb226e0a688f5e68$export$adaa4cf7ef1b65be = function(key) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    //
    if (value === undefined) value = null;
    else value = JSON.stringify(value);
    //
    try {
        window.sessionStorage.setItem(key, value);
    } catch (e) {
        console.log(e);
    }
};
$eb226e0a688f5e68$export$cd7f480d6b8286c3 = function(key) {
    window.localStorage.removeItem(key);
};

});

parcelRegister("7K4bb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5a301235592ef710$export$7c398597f8905a1; });
function $5a301235592ef710$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5a301235592ef710$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5a301235592ef710$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5a301235592ef710$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("cX5iq", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $96df1a734f61a8a0$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $h9OH6 = parcelRequire("h9OH6");
var $96df1a734f61a8a0$var$extendStatics = function extendStatics1(d, b) {
    $96df1a734f61a8a0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $96df1a734f61a8a0$var$extendStatics(d, b);
};
function $96df1a734f61a8a0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $96df1a734f61a8a0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $96df1a734f61a8a0$export$18ce0697a983be9b = function __assign1() {
    $96df1a734f61a8a0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96df1a734f61a8a0$export$18ce0697a983be9b.apply(this, arguments);
};
function $96df1a734f61a8a0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $96df1a734f61a8a0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $96df1a734f61a8a0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $96df1a734f61a8a0$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $96df1a734f61a8a0$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $96df1a734f61a8a0$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $h9OH6._)(x)) === "symbol" ? x : "".concat(x);
}
function $96df1a734f61a8a0$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $h9OH6._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $96df1a734f61a8a0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $96df1a734f61a8a0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $96df1a734f61a8a0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $96df1a734f61a8a0$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $96df1a734f61a8a0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $96df1a734f61a8a0$export$45d3717a4c69092e(o, m, p);
}
function $96df1a734f61a8a0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $96df1a734f61a8a0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $96df1a734f61a8a0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($96df1a734f61a8a0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $96df1a734f61a8a0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $96df1a734f61a8a0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $96df1a734f61a8a0$export$10c90e4f7922046c(v) {
    return this instanceof $96df1a734f61a8a0$export$10c90e4f7922046c ? (this.v = v, this) : new $96df1a734f61a8a0$export$10c90e4f7922046c(v);
}
function $96df1a734f61a8a0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $96df1a734f61a8a0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $96df1a734f61a8a0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $96df1a734f61a8a0$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $96df1a734f61a8a0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $96df1a734f61a8a0$export$19a8beecd37a4c45 === "function" ? $96df1a734f61a8a0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $96df1a734f61a8a0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $96df1a734f61a8a0$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $96df1a734f61a8a0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $96df1a734f61a8a0$export$45d3717a4c69092e(result, mod, k);
    }
    $96df1a734f61a8a0$var$__setModuleDefault(result, mod);
    return result;
}
function $96df1a734f61a8a0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $96df1a734f61a8a0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $96df1a734f61a8a0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $96df1a734f61a8a0$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $96df1a734f61a8a0$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $96df1a734f61a8a0$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $96df1a734f61a8a0$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $96df1a734f61a8a0$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $96df1a734f61a8a0$export$2e2bcd8739ae039 = {
    __extends: $96df1a734f61a8a0$export$a8ba968b8961cb8a,
    __assign: $96df1a734f61a8a0$export$18ce0697a983be9b,
    __rest: $96df1a734f61a8a0$export$3c9a16f847548506,
    __decorate: $96df1a734f61a8a0$export$29e00dfd3077644b,
    __param: $96df1a734f61a8a0$export$d5ad3fd78186038f,
    __metadata: $96df1a734f61a8a0$export$f1db080c865becb9,
    __awaiter: $96df1a734f61a8a0$export$1050f835b63b671e,
    __generator: $96df1a734f61a8a0$export$67ebef60e6f28a6,
    __createBinding: $96df1a734f61a8a0$export$45d3717a4c69092e,
    __exportStar: $96df1a734f61a8a0$export$f33643c0debef087,
    __values: $96df1a734f61a8a0$export$19a8beecd37a4c45,
    __read: $96df1a734f61a8a0$export$8d051b38c9118094,
    __spread: $96df1a734f61a8a0$export$afc72e2116322959,
    __spreadArrays: $96df1a734f61a8a0$export$6388937ca91ccae8,
    __spreadArray: $96df1a734f61a8a0$export$1216008129fb82ed,
    __await: $96df1a734f61a8a0$export$10c90e4f7922046c,
    __asyncGenerator: $96df1a734f61a8a0$export$e427f37a30a4de9b,
    __asyncDelegator: $96df1a734f61a8a0$export$bbd80228419bb833,
    __asyncValues: $96df1a734f61a8a0$export$e3b29a3d6162315f,
    __makeTemplateObject: $96df1a734f61a8a0$export$4fb47efe1390b86f,
    __importStar: $96df1a734f61a8a0$export$c21735bcef00d192,
    __importDefault: $96df1a734f61a8a0$export$da59b14a69baef04,
    __classPrivateFieldGet: $96df1a734f61a8a0$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $96df1a734f61a8a0$export$d40a35129aaff81f,
    __classPrivateFieldIn: $96df1a734f61a8a0$export$81fdc39f203e4e04,
    __addDisposableResource: $96df1a734f61a8a0$export$88ac25d8e944e405,
    __disposeResources: $96df1a734f61a8a0$export$8f076105dc360e92
};

});
parcelRegister("h9OH6", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $c7da99bc8f965133$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $c7da99bc8f965133$export$5f0017c582d45a2d; });
function $c7da99bc8f965133$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("lT1Za", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fef04652c775fc64$export$1b5e630bc3aea29f; });

var $cOS50 = parcelRequire("cOS50");

var $i1nao = parcelRequire("i1nao");

var $7HS0T = parcelRequire("7HS0T");

var $8YVFh = parcelRequire("8YVFh");
function $fef04652c775fc64$export$1b5e630bc3aea29f(arr) {
    return (0, $cOS50._array_without_holes)(arr) || (0, $i1nao._iterable_to_array)(arr) || (0, $8YVFh._unsupported_iterable_to_array)(arr) || (0, $7HS0T._non_iterable_spread)();
}

});
parcelRegister("cOS50", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $95541aa473131508$export$7e0947b5ad3404e2; });

var $822BU = parcelRequire("822BU");
function $95541aa473131508$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $822BU._array_like_to_array)(arr);
}

});

parcelRegister("i1nao", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $d1ea4a6590f30b83$export$1eb58a6e75231000; });
function $d1ea4a6590f30b83$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("7HS0T", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $59c6727f1c363cc6$export$e6f3c4780d19eb2b; });
function $59c6727f1c363cc6$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fZi8Q", function(module, exports) {
/**
* Use the Fetch API to access RESTful api resources
*/ 
var $7K4bb = parcelRequire("7K4bb");

var $eqJqJ = parcelRequire("eqJqJ");

var $cX5iq = parcelRequire("cX5iq");
module.exports = function() {
    var _ref = (0, $7K4bb._)(function(method, endpoint, params, payload) {
        var endpointURL, options, response, submittedForm, responseObject, _responseObject_details, _ref;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    //
                    endpointURL = new URL(endpoint, location.origin);
                    //append any query params
                    if (params !== undefined && params !== null) endpointURL.search = new URLSearchParams(params).toString();
                    //handle the payload
                    options = function(payload) {
                        if (payload !== undefined && payload !== null) {
                            if (payload instanceof FormData) return {
                                "body": payload
                            };
                            return {
                                "headers": {
                                    "Content-Type": "application/json"
                                },
                                "body": JSON.stringify(payload || {})
                            };
                        }
                        return {};
                    }(payload);
                    return [
                        4,
                        fetch(endpointURL, (0, $eqJqJ._)({
                            "method": method.toUpperCase()
                        }, options || {}))
                    ];
                case 1:
                    response = _state.sent();
                    //
                    if (response.headers.has("X-FORM-NAME") && response.headers.has("X-FORM-CSRF-TOKEN")) {
                        submittedForm = document.querySelector('form[name="'.concat(response.headers.get("X-FORM-NAME"), '"] input[name="form-csrf-token"]'));
                        if (submittedForm !== null) submittedForm.value = response.headers.get("X-FORM-CSRF-TOKEN");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    responseObject = _state.sent();
                    return [
                        2,
                        [
                            responseObject.status,
                            (_ref = (_responseObject_details = responseObject.details) !== null && _responseObject_details !== void 0 ? _responseObject_details : responseObject.message) !== null && _ref !== void 0 ? _ref : responseObject
                        ]
                    ];
            }
        });
    });
    return function(method, endpoint, params, payload) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("eqJqJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a816bbdc611717bc$export$581ff339ea0ba762; });

var $fk4tK = parcelRequire("fk4tK");
function $a816bbdc611717bc$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $fk4tK._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("fk4tK", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $b27c32a9a48eff19$export$1e71eb4bef00f6b0; });
function $b27c32a9a48eff19$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});



parcelRegister("03Gk5", function(module, exports) {

var $4j8k4 = parcelRequire("4j8k4");

var $bYFju = parcelRequire("bYFju");
var $00b11c625104a135$var$ScrollSpy = /*#__PURE__*/ function() {
    "use strict";
    function ScrollSpy(menuSelector, sectionSelector) {
        (0, $4j8k4._)(this, ScrollSpy);
        this.menuItems = document.querySelectorAll(menuSelector);
        this.sections = document.querySelectorAll(sectionSelector);
        this.init();
    }
    (0, $bYFju._)(ScrollSpy, [
        {
            //
            key: "init",
            value: function init() {
                //
                var options = {
                    root: null,
                    rootMargin: "120px",
                    threshold: 0.7
                };
                //
                var observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
                this.sections.forEach(function(section) {
                    return observer.observe(section);
                });
            }
        },
        {
            //
            key: "handleIntersection",
            value: function handleIntersection(entries) {
                var _this = this;
                //
                entries.forEach(function(entry) {
                    //
                    if (entry.isIntersecting) {
                        var targetName = entry.target.name;
                        _this.setActiveMenuItem(targetName);
                    }
                });
            }
        },
        {
            //
            key: "setActiveMenuItem",
            value: function setActiveMenuItem(targetName) {
                var _this = this;
                //
                this.menuItems.forEach(function(item) {
                    //
                    item.classList.remove("active");
                    //
                    if (_this.getHref(item) === "#".concat(targetName)) item.classList.add("active");
                });
            }
        },
        {
            //
            key: "enableSmoothScroll",
            value: function enableSmoothScroll() {
                var _this = this;
                //
                this.menuItems.forEach(function(link) {
                    //
                    link.addEventListener("click", function(event) {
                        //
                        var href = _this.getHref(link);
                        //
                        if (href.startsWith("#")) {
                            //
                            event.preventDefault();
                            //
                            var targetName = href.substring(1);
                            var targetElement = document.querySelector('a[name="'.concat(targetName, '"]'));
                            //
                            if (targetElement) targetElement.scrollIntoView({
                                behavior: "smooth"
                            });
                        }
                    });
                });
            }
        },
        {
            //
            key: "getHref",
            value: function getHref(element) {
                //
                var href = "";
                var anchor = "";
                //
                if (href = element.getAttribute("href")) return href;
                //
                if (anchor = element.querySelector("a")) href = anchor.getAttribute("href");
                //
                return href;
            }
        }
    ]);
    return ScrollSpy;
}();
//
module.exports = $00b11c625104a135$var$ScrollSpy;

});
parcelRegister("4j8k4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $322f647cc014c259$export$2996f80ef42b8419; });
function $322f647cc014c259$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("bYFju", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8b85584a9c60bd7b$export$d60067ff2358eee8; });
function $8b85584a9c60bd7b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8b85584a9c60bd7b$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $8b85584a9c60bd7b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8b85584a9c60bd7b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


parcelRegister("cEi7m", function(module, exports) {
//

var $7K4bb = parcelRequire("7K4bb");

var $cX5iq = parcelRequire("cX5iq");

var $6TBCQ = parcelRequire("6TBCQ");

var $70P4J = parcelRequire("70P4J");

var $k2ek2 = parcelRequire("k2ek2");
//load the external editor javascript if needed, and run the supplied callback once loaded
module.exports.loadEditor = /*#__PURE__*/ (0, $7K4bb._)(function() {
    var editorScript;
    return (0, $cX5iq.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                //if the ckeditor global is already defined, then the loading has been complete so we can call the callback immediatly
                if (typeof CKEDITOR !== "undefined") return [
                    2
                ];
                //start loading the ckeditor script
                editorScript = $70P4J("script", {
                    "src": "/js/thirdparty/ckeditor/ckeditor.js"
                });
                document.querySelector("head").append(editorScript);
                //
                return [
                    4,
                    $6TBCQ(function() {
                        return typeof CKEDITOR !== "undefined";
                    }, 100)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
});
//==============================================================================
//define a "simple" editor config
module.exports.createSimpleContentEditor = function() {
    var _ref = (0, $7K4bb._)(function(element) {
        var editor;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    //
                    return [
                        4,
                        this.loadEditor()
                    ];
                case 1:
                    _state.sent();
                    //
                    editor = CKEDITOR.replace(element.id, {
                        toolbar: [
                            {
                                items: [
                                    "Undo",
                                    "Redo"
                                ]
                            },
                            {
                                items: [
                                    "Bold",
                                    "Italic",
                                    "Underline",
                                    "-",
                                    "Subscript",
                                    "Superscript",
                                    "-",
                                    "NumberedList",
                                    "BulletedList"
                                ]
                            }
                        ]
                    });
                    //apply custom css for the editor
                    editor.config.contentsCss = "/css/ckeditor.min.css";
                    //make smaller, remove bottom bar, reduce padding - can i make this use an iline editor
                    editor.config.removePlugins = "elementspath";
                    editor.config.resize_enabled = false;
                    //have the editor update the source element on each change (debounced)
                    editor.on("change", $k2ek2(200, function() {
                        editor.updateElement();
                    }));
                    //
                    return [
                        2,
                        editor
                    ];
            }
        });
    });
    return function(element) {
        return _ref.apply(this, arguments);
    };
}();
//==============================================================================
//define a "full" editor config
module.exports.createFullContentEditor = function() {
    var _ref = (0, $7K4bb._)(function(element) {
        var editor;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    //
                    return [
                        4,
                        this.loadEditor()
                    ];
                case 1:
                    _state.sent();
                    //
                    editor = CKEDITOR.replace(element.id, {
                        toolbar: [
                            {
                                items: [
                                    "Cut",
                                    "Copy",
                                    "Paste",
                                    "PasteText",
                                    "PasteFromWord",
                                    "-",
                                    "Undo",
                                    "Redo"
                                ]
                            },
                            {
                                items: [
                                    "Bold",
                                    "Italic",
                                    "Underline",
                                    "Strike",
                                    "-",
                                    "Subscript",
                                    "Superscript",
                                    "-",
                                    "RemoveFormat"
                                ]
                            },
                            {
                                items: [
                                    "Link",
                                    "Unlink",
                                    "-",
                                    "Table",
                                    "-",
                                    "NumberedList",
                                    "BulletedList",
                                    "Outdent",
                                    "Indent"
                                ]
                            },
                            {
                                items: [
                                    "Maximize"
                                ]
                            }
                        ]
                    });
                    //
                    editor.config.resize_enabled = false;
                    //have the editor update the source element on each change (debounced)
                    editor.on("change", $k2ek2(200, function() {
                        editor.updateElement();
                    }));
                    //
                    return [
                        2,
                        editor
                    ];
            }
        });
    });
    return function(element) {
        return _ref.apply(this, arguments);
    };
}();
//==============================================================================
//define a "custom" editor config
module.exports.createCustomContentEditor = function() {
    var _ref = (0, $7K4bb._)(function(element, buttons) {
        var editor;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    //
                    return [
                        4,
                        this.loadEditor()
                    ];
                case 1:
                    _state.sent();
                    //set the editor up with the custom buttons
                    editor = CKEDITOR.replace(element.id, {
                        "toolbar": buttons
                    });
                    //remove the "path" at the bottom of the editor
                    editor.config.removePlugins = "elementspath";
                    //do not allow the user to resize the editor
                    editor.config.resize_enabled = false;
                    //have the editor update the source element on each change (debounced)
                    editor.on("change", $k2ek2(200, function() {
                        editor.updateElement();
                    }));
                    //
                    return [
                        2,
                        editor
                    ];
            }
        });
    });
    return function(element, buttons) {
        return _ref.apply(this, arguments);
    };
}(); //==============================================================================

});
parcelRegister("6TBCQ", function(module, exports) {
/**
 * await until the result of the {callback} is true, poll the callback every {delay} milliseconds
 */ 
var $7K4bb = parcelRequire("7K4bb");

var $cX5iq = parcelRequire("cX5iq");
module.exports = function() {
    var _ref = (0, $7K4bb._)(function(callback, delay) {
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new Promise(function(resolve) {
                            var interval = setInterval(function() {
                                if (callback()) {
                                    resolve();
                                    clearInterval(interval);
                                }
                            }, delay);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function(callback, delay) {
        return _ref.apply(this, arguments);
    };
}();

});


parcelRegister("dVE5d", function(module, exports) {
/**
 * Simple micro template system, based off John Resig's original function and other user contributions
 *
 * @package Mercury
 * @copyright 2021 National Residential Landlords Association
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */ //==============================================================================
//

var $haqKc = parcelRequire("haqKc");
module.exports = function(template, data) {
    var template_name = "zeno-template-cache-" + template;
    if (typeof window[template_name] == "undefined") window[template_name] = $a23fb0ec03d1c4b9$var$zeno_prepare_template(document.getElementById(template).innerHTML);
    return window[template_name](data || {});
};
//==============================================================================
//store all the callbacks that we want to use as filters
window.zeno_filter_callbacks = {}; //!!!
//add a function to allow adding of new filters
function $a23fb0ec03d1c4b9$var$zeno_template_add_filter(name, callback) {
    if (typeof callback === "function") zeno_filter_callbacks[name] = callback;
}
//==============================================================================
//declare some basic filters
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("upper", function(value) {
    return value !== null ? value.toUpperCase() : "";
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("lower", function(value) {
    return value !== null ? value.toLowerCase() : "";
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("title", function(value) {
    return value !== null ? value.toTitleCase() : "";
});
//twig like replace filter
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("replace", function(haystack, replacements) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(replacements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $haqKc._)(_step.value, 2), needle = _step_value[0], value = _step_value[1];
            haystack = haystack.replace(needle, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return haystack;
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("default", function(value, ifnull) {
    return value == "" ? ifnull : value;
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("number_format", function(value, precision, zero_value) {
    if (value === null || isNaN(value) || value == 0) return typeof zero_value !== "undefined" ? zero_value : null;
    return parseInt(value, 10).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parseInt(precision, 10) > 0 ? value.toFixed(precision).slice(-(precision + 1)) || "." + "0".repeat(precision) : "");
});
//==============================================================================
/**
 * Simple micro template system, based off John Resig's original function and other user contributions
 * @param  {string} template Required - The id of the template to render
 * @param  {object} data     Optional - The data to pass into the template renderer
 * @return {string}
 */ function $a23fb0ec03d1c4b9$var$zeno_prepare_template(template) {
    //remove any whitespace characters inside our [[ and ]] operators
    template = template.replace(/\[\[(\s+)/g, "[[");
    template = template.replace(/(\s+)\]\]/g, "]]");
    //allow the user to set variables for use later in the template
    template = template.replace(/\[\[set (.+)\]\]/g, "[[var $1;]]");
    //pre-parse some common commands into "native" template language
    template = template.replace(/\[\[if([^{]+?)\]\]/g, "[[ if ($1) { ]]"); // "[^{]" vs "." to prevent it from parsing the legacy if conditions
    template = template.replace(/\[\[else\]\]/g, "[[ } else { ]]");
    template = template.replace(/\[\[endif\]\]/g, "[[ } ]]");
    //for loops
    template = template.replace(/\[\[for ([^\(]+?) in (.+?)\]\]/g, "[[ if (typeof $2 !== 'undefined') { for (var _$1 in $2 ) { if ($2.hasOwnProperty(_$1)) { var $1 = $2[_$1], loop = {'index':_$1}; ]]");
    template = template.replace(/\[\[endfor\]\]/g, "[[ }}} ]]");
    //ternary if statements
    template = template.replace(/\[\[iif\((.+?),(.+?),(.+?)\)\]\]/g, "[[p.push((($1) ? $2 : $3));]]");
    template = template.replace(/\[\[iif\((.+?),(.+?)\)\]\]/g, "[[p.push((($1) ? $2 : ''));]]");
    //allow templates to be included from within other templates
    template = template.replace(/\[\[include(.+)with(.+)\]\]/g, "[[p.push(zeno_template($1, $.extend({}, data, $2)));]]");
    template = template.replace(/\[\[include(.+)\]\]/g, "[[p.push(zeno_template($1, data));]]");
    //condense any whitespace into a single space character
    template = template.replace(/[\r\t\n]/g, " ");
    //process any "echo" expressions
    template = template.replace(/\[\[=(.+?)\]\]/g, function(match, variable) {
        //process the string if it contains filters - currently only allowing 1 filter
        if ((filter = variable.match(/(.+?)\|(.+?)\((.+?)?\)/)) !== null && typeof zeno_filter_callbacks[filter[2]] == "function") return "',((typeof " + filter[1] + " !== 'undefined') ? zeno_filter_callbacks['" + filter[2] + "'](" + filter[1] + (filter[3] != undefined ? ", " + filter[3] : "") + ") : ''),'";
        //just a standard expression
        return "',((typeof " + variable + " !== 'undefined') ? " + variable + " : ''),'";
    });
    //
    template = template.replace(/\[\[/g, "');");
    template = template.replace(/\]\]/g, "p.push('");
    try {
        var template_callback = new Function("data", "var p = [], print = function() { p.push.apply(p, arguments); }; with(data) { p.push('" + template + "'); } return p.join('');");
        return template_callback;
    } catch (exception) {
        console.error(exception);
        console.error(template);
    }
    return "";
} //==============================================================================

});

parcelRegister("dRAC6", function(module, exports) {
//

var $70P4J = parcelRequire("70P4J");
/**
 * Create a one way binding so as the property is updated, the DOM is also updated
 * @param  string target   Required - A selector or reference to the hidden input that this recaptcha is attached to
 * @param  string callback Optional - A callback to be executed after the recaptcha has a response
 * @return void
 */ module.exports = function(target, callback) {
    //
    var grecaptchaLoadedCallback = function() {
        //
        var grecaptchaInput = typeof target === "string" ? document.querySelector(target) : target;
        //
        var grecaptchaContainer = $70P4J("div");
        //
        grecaptchaInput.parentElement.append(grecaptchaContainer);
        //
        grecaptchaInput.dataset.grecaptchaWidgetID = grecaptcha.render(grecaptchaContainer, {
            "sitekey": grecaptchaInput.dataset.grecaptchaSiteKey,
            "callback": function(response) {
                grecaptchaInput.value = response;
                if (typeof callback === "function") callback.call(grecaptchaInput, response);
            }
        });
    };
    //if the grecaptcha function already exists, then the library has already loaded, so just call our loaded callback immediately
    if (typeof window.grecaptcha === "function") {
        grecaptchaLoadedCallback();
        return;
    }
    //has the grecaptcha library already started to be loaded?
    if (typeof window.grecaptchaCallbacks === "undefined" && typeof window.grecaptchaLoadedCallback === "undefined") {
        //start loading the captcha api
        var captchaScript = $70P4J("script", {
            "src": "https://www.google.com/recaptcha/api.js?onload=grecaptchaLoadedCallback&render=explicit",
            "async": "async",
            "defer": "defer"
        });
        document.querySelector("head").append(captchaScript);
        //
        window.grecaptchaCallbacks = [];
        //
        window.grecaptchaLoadedCallback = function() {
            window.grecaptchaCallbacks.map(function(grecaptchaCallback) {
                grecaptchaCallback();
            });
        };
    }
    //as it's already loading - just add our callback to the queue
    window.grecaptchaCallbacks.push(grecaptchaLoadedCallback);
};

});

parcelRegister("lNLDS", function(module, exports) {
/**
 * Wrap up a fetch call to reduce the boiler plate for simple internal get requests
 * @deprecated use zenoFetch
 * @param  string endpoint Required - The endpoint that we want to get the information from
 * @param  string params   Optional - Any params to be sent (as an object)
 * @return void
 */ module.exports = function(endpoint, params) {
    //convert the endpoint into a url instance
    endpoint = new URL(endpoint, location.origin);
    //add the params to the endpoint
    if (typeof params !== "undefined") endpoint.search = new URLSearchParams(params).toString();
    //
    return fetch(endpoint, {
        "method": "get"
    }).then(function(response) {
        return response.json();
    }).catch(function(error) {
        console.error(error);
    });
};

});

parcelRegister("eHUQL", function(module, exports) {
//------------------------------------------------------------------------------
//

var $lT1Za = parcelRequire("lT1Za");
if (document.querySelector("form.training-booking-form") === null) return;

var $70P4J = parcelRequire("70P4J");

var $dVE5d = parcelRequire("dVE5d");

var $lvQSp = parcelRequire("lvQSp");

var $lNLDS = parcelRequire("lNLDS");

var $k2ek2 = parcelRequire("k2ek2");
//------------------------------------------------------------------------------
//
var additionalDelegatesContainer = document.querySelector(".additional-delegates");
//define a object to store our process, this will make use of a one way binding to update the dom as the values are changed
var coursePricing = {};
//setup one-way binding so we can update the prices on the page
Object.defineProperty(coursePricing, "memberBookingFee", $lvQSp("memberBookingFee", 'span[data-binding="member-booking-fee"]'));
Object.defineProperty(coursePricing, "nonMemberBookingFee", $lvQSp("nonMemberBookingFee", 'span[data-binding="non-member-booking-fee"]'));
//set the default baseline prices up
var pricingSource = document.querySelector(".training-booking-form");
coursePricing.memberBookingFee = pricingSource.dataset.memberBookingFee;
coursePricing.nonMemberBookingFee = pricingSource.dataset.nonMemberBookingFee;
//if the "same day event" bundle is selected - update the prices
var sameDayBundleInput = document.querySelector('input[name="includeBundleDeal"]');
if (typeof sameDayBundleInput !== "undefined" && sameDayBundleInput !== null) sameDayBundleInput.addEventListener("change", function(event) {
    var pricingSource = document.querySelector(event.target.checked === true ? ".training-event-bundle" : ".training-booking-form");
    coursePricing.memberBookingFee = pricingSource.dataset.memberBookingFee;
    coursePricing.nonMemberBookingFee = pricingSource.dataset.nonMemberBookingFee;
});
//toggle the display of the "additional questions" when selecting a member/associate while logged in
var selectedDelegateButtons = document.querySelectorAll('.training-delegate input[name="delegates[]"]');
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
if (typeof selectedDelegateButtons !== "undefined" && selectedDelegateButtons.length > 0) try {
    for(var _iterator = selectedDelegateButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var selectedDelegateButton = _step.value;
        selectedDelegateButton.addEventListener("change", function(event) {
            var delegateWrapper = event.target.closest(".training-delegate");
            delegateWrapper.classList.toggle("selected", event.target.checked);
        });
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
//add events the additional delegate form
function applyAdditionalDelegateEvents(additionalDelegateForm) {
    //check the the email address is not in use by an existing member (this is just a note - not a validation file)
    var additionalDelegateEmailInput = additionalDelegateForm.querySelector('input[name^="additionalDelegateEmail"]');
    additionalDelegateEmailInput.addEventListener("change", function(event) {
        $lNLDS("/training-academy/actions/check-email-address", {
            "email": event.target.value
        }).then(function(response) {
            if (response.status === "error") {
                var additionalDelegateEmailInputGroup = additionalDelegateEmailInput.closest(".input-group");
                additionalDelegateEmailInputGroup.append($70P4J("div", {}, response.message));
            }
        });
    });
    //allow the additional delegate to be removed
    var additionalDelegateRemoveButton = additionalDelegateForm.querySelector('button[data-action="remove-delegate"]');
    if (additionalDelegateRemoveButton !== null) additionalDelegateRemoveButton.addEventListener("click", $k2ek2(200, function(event) {
        additionalDelegateForm.remove();
    }));
}
//
var additionalDelegateForms = additionalDelegatesContainer.querySelectorAll(".training-delegate");
var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
try {
    for(var _iterator1 = additionalDelegateForms[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
        var additionalDelegateForm = _step1.value;
        applyAdditionalDelegateEvents(additionalDelegateForm);
    }
} catch (err) {
    _didIteratorError1 = true;
    _iteratorError1 = err;
} finally{
    try {
        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
            _iterator1.return();
        }
    } finally{
        if (_didIteratorError1) {
            throw _iteratorError1;
        }
    }
}
//add a new "delegate" form to enable booking multiple delegates at once
var addAdditionalDelegateButton = document.querySelector('button[data-action="add-additional-delegate"]');
addAdditionalDelegateButton.addEventListener("click", $k2ek2(200, function(event) {
    //get the max "additional delegate index" and add 1
    var additionalDelegatesInputs = additionalDelegatesContainer.querySelectorAll('input[name="additionalDelegates[]"]');
    var delegateCount = (0, $lT1Za._)(additionalDelegatesInputs).reduce(function(acc, cur) {
        return Math.max(acc, cur.value);
    }, 0) + 1;
    //
    additionalDelegatesContainer.insertAdjacentHTML("beforeend", $dVE5d("tpl-training-delegate-form", {
        "nonMemberBookingFee": coursePricing.nonMemberBookingFee
    }));
    var additionalDelegateForm = additionalDelegatesContainer.querySelector(".training-delegate:last-child");
    //set the value of the additionalDelegates input - this will allow us to validate etc
    var additionalDelegatesInput = additionalDelegateForm.querySelector('input[name="additionalDelegates[]"]');
    if (typeof additionalDelegatesInput !== "undefined") additionalDelegatesInput.value = delegateCount;
    //find all the label/input/select/textarea elements, and mutate the for/name/id attribute to add the new "index"
    var elements = additionalDelegateForm.querySelectorAll('label, input:not([name="additionalDelegates[]"]), select, textarea');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (typeof elements !== "undefined" && elements.length > 0) try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            for(var _i = 0, _iter = [
                "for",
                "id",
                "name"
            ]; _i < _iter.length; _i++){
                var attribute = _iter[_i];
                if (element.hasAttribute(attribute)) element.setAttribute(attribute, element.getAttribute(attribute) + String(delegateCount));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    //
    applyAdditionalDelegateEvents(additionalDelegateForm);
})); //------------------------------------------------------------------------------

});
parcelRegister("lvQSp", function(module, exports) {
/**
 * Create a one way binding so as the property is updated, the DOM is also updated
 * @param  string property Required - The name of the property to be bound
 * @param  string selector Required the selector that matches the elements to be updated
 * @return void
 */ module.exports = function(property, selector) {
    return {
        //
        get: function get() {
            var _this__values_property;
            return (_this__values_property = this._values[property]) !== null && _this__values_property !== void 0 ? _this__values_property : undefined;
        },
        //
        set: function set(value) {
            //
            if (this._values === undefined) this._values = {};
            //
            this._values[property] = value;
            //
            var elements = document.querySelectorAll(selector);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (typeof elements !== "undefined" && elements.length > 0) try {
                for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var element = _step.value;
                    element.textContent = value;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
};

});


parcelRegister("bZLPO", function(module, exports) {
//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");

var $fZi8Q = parcelRequire("fZi8Q");
//
var trainingCourseFilterForm = document.querySelector(".trainingCourseSearch");
//
var allTrainingSearchResults = document.querySelector("#allTrainingSearchResults");
//
if (trainingCourseFilterForm == null || allTrainingSearchResults == null) return;
//
trainingCourseFilterForm.addEventListener("submit", function() {
    var _ref = (0, $7K4bb._)(function(event) {
        var trainingCourseFilterFormData, payload, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, _ref, status, response, searchResults;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    //
                    event.preventDefault();
                    //
                    trainingCourseFilterFormData = new FormData(trainingCourseFilterForm);
                    //
                    payload = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        //
                        for(_iterator = trainingCourseFilterFormData.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            input = _step.value;
                            payload[input[0]] = input[1];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        $fZi8Q("post", "/api/training-search", null, payload)
                    ];
                case 1:
                    _ref = (0, $haqKc._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), status = _ref[0], response = _ref[1];
                    //
                    searchResults = response.searchResults;
                    //
                    if (status == "success") {
                        //
                        dayjs.locale("en");
                        //
                        allTrainingSearchResults.innerHTML = zeno_template("tpl-training-search-results", {
                            searchResults: searchResults
                        });
                    }
                    //
                    document.querySelector('input[name="trainingSearchFromDateFilter"]').value = payload.trainingSearchFromDateFilter;
                    document.querySelector('input[name="trainingSearchToDateFilter"]').value = payload.trainingSearchToDateFilter;
                    //
                    document.querySelector('select[name="trainingSearchCPDFilter"]').setAttribute("data-selected", "".concat(payload.trainingSearchCPDFilter));
                    document.querySelector('select[name="trainingSearchCourseTypeFilter"]').setAttribute("data-selected", "".concat(payload.trainingSearchCourseTypeFilter));
                    return [
                        2
                    ];
            }
        });
    });
    return function(event) {
        return _ref.apply(this, arguments);
    };
}());

});

//include any "progressive enhancements" - these will look for markup on the page
//if all the links are flagged as opened - then allow the checkbox to be selected
var $128a90d335caa27a$var$becomingRegisteredForm = document.querySelector('form[name="becoming-registered"]');
if ($128a90d335caa27a$var$becomingRegisteredForm !== null) Array.from($128a90d335caa27a$var$becomingRegisteredForm.querySelectorAll("a[data-opened]")).map(function(link) {
    link.addEventListener("click", function() {
        link.setAttribute("data-opened", -1);
        icon = link.closest("p").querySelector("i");
        icon.classList.remove("fa-circle");
        icon.classList.add("fa-check");
        if ($128a90d335caa27a$var$becomingRegisteredForm.querySelectorAll("a[data-opened]").length === $128a90d335caa27a$var$becomingRegisteredForm.querySelectorAll('a[data-opened="-1"]').length) {
            //
            var becomingRegisteredCheckbox = $128a90d335caa27a$var$becomingRegisteredForm.querySelector('input[type="checkbox"]');
            becomingRegisteredCheckbox.disabled = false;
            becomingRegisteredCheckbox.checked = true;
            //
            var submitButton = $128a90d335caa27a$var$becomingRegisteredForm.querySelector('[name="submit-termsandconditions"]');
            submitButton.disabled = false;
            submitButton.classList.remove("btn-disabled");
        }
    });
});


//
var $c318455e277f2706$var$addressLookup = document.querySelector(".address-lookup");
var $c318455e277f2706$var$addressLookupResults = document.querySelector(".address-lookup .address-lookup-results");



if ($c318455e277f2706$var$addressLookup !== null && $c318455e277f2706$var$addressLookupResults !== null) {
    var $c318455e277f2706$var$retrieveAddress = //
    function retrieveAddress(container) {
        //
        var endpoint = "https://api.addressy.com/Capture/Interactive/Retrieve/v1.0/json3.ws";
        var params = {
            "Key": $c318455e277f2706$var$addressLookup.dataset.key,
            "Id": container
        };
        //
        $c318455e277f2706$var$emptyElement($c318455e277f2706$var$addressLookupResults);
        //
        return fetch(endpoint + "?" + new URLSearchParams(params).toString(), {
            "method": "GET"
        }).then(function(response) {
            return response.json();
        }).then(function(response) {
            var address = response.Items[0];
            //get the first 3 lines of the address, allowing company name to bump line 3 away, and remove any empty elements
            var addressParts = [
                address.Company,
                address.Line1,
                address.Line2,
                address.Line3,
                address.Line4,
                address.Line5
            ].filter(function(part) {
                return part != null && part != "";
            }).splice(0, 3);
            var _addressParts_, _addressParts_1, _addressParts_2;
            //
            window[$c318455e277f2706$var$addressLookup.dataset.callback].call(undefined, {
                "line1": (_addressParts_ = addressParts[0]) !== null && _addressParts_ !== void 0 ? _addressParts_ : null,
                "line2": (_addressParts_1 = addressParts[1]) !== null && _addressParts_1 !== void 0 ? _addressParts_1 : null,
                "line3": (_addressParts_2 = addressParts[2]) !== null && _addressParts_2 !== void 0 ? _addressParts_2 : null,
                "town": address.City,
                "county": address.Province,
                "country": address.CountryIso2,
                "postcode": address.PostalCode
            });
            //display the address fields, and hide the "search" box
            if (!$c318455e277f2706$var$addressLookup.dataset.nohide) $c318455e277f2706$var$addressLookup.style.display = "none";
        }).catch(function(error) {
            console.error(error);
        });
    };
    //
    var $c318455e277f2706$var$debounce = (parcelRequire("k2ek2"));
    var $c318455e277f2706$var$createElement = (parcelRequire("70P4J"));
    var $c318455e277f2706$var$emptyElement = (parcelRequire("8j5OG"));
    //
    document.querySelector('input[name="postcodeLookup"]').addEventListener("keydown", $c318455e277f2706$var$debounce(500, function(event) {
        //
        if ([
            "ArrowUp",
            "ArrowDown",
            "Enter"
        ].includes(event.key)) return true;
        //
        var postcodeInput = document.querySelector('input[name="postcodeLookup"]');
        if (postcodeInput != null && postcodeInput.value.length >= 5) findAddresses();
    }));
    //
    function findAddresses(container) {
        //
        var postcodeInput = $c318455e277f2706$var$addressLookup.querySelector('input[name="postcodeLookup"]');
        if (postcodeInput == null || postcodeInput.value.length <= 3) return false;
        //
        var endpoint = "https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws";
        var params = {
            "Key": $c318455e277f2706$var$addressLookup.dataset.key,
            "Text": postcodeInput.value,
            "IsMiddleware": false,
            "Container": typeof container == "undefined" ? null : container,
            "Origin": "",
            "Countries": "GBR",
            "Limit": 99,
            "Language": "en-gb"
        };
        //
        return fetch(endpoint + "?" + new URLSearchParams(params).toString(), {
            "method": "GET"
        }).then(function(response) {
            return response.json();
        }).then(function(response) {
            //
            var addresses = response.Items;
            //if we only got a single address, and it's not actually an address, search using that addresses id
            if (addresses.length == 1 && addresses[0].Type != "Address") findAddresses(addresses[0].Id);
            //if we have one or more results, then show them to the user for them to make a selection on
            if (addresses.length > 1 || addresses.length == 1 && addresses.Type == "Address") {
                //
                $c318455e277f2706$var$emptyElement($c318455e277f2706$var$addressLookupResults);
                //
                addresses.forEach(function(address) {
                    //
                    var addressLookupResult = $c318455e277f2706$var$createElement("div", {
                        "data-id": address.Id,
                        "data-type": address.Type,
                        "data-text": address.Text,
                        "data-highlight": address.Highlight,
                        "data-description": address.Description
                    });
                    //
                    addressLookupResult.appendChild(document.createTextNode(address.Text + " " + address.Description));
                    //
                    $c318455e277f2706$var$addressLookupResults.appendChild(addressLookupResult);
                });
            }
        }).catch(function(error) {
            console.error(error);
        });
    }
    //add mouse functionality to the address result list
    $c318455e277f2706$var$addressLookupResults.addEventListener("mousedown", function(event) {
        if ((activeResult = $c318455e277f2706$var$addressLookupResults.querySelector("div.active")) !== null) activeResult.classList.remove("active");
        event.target.classList.add("active");
    });
    $c318455e277f2706$var$addressLookupResults.addEventListener("mouseup", function(event) {
        if ((activeResult = $c318455e277f2706$var$addressLookupResults.querySelector("div.active")) !== null && activeResult == event.target) {
            if (activeResult.dataset.type == "Address") $c318455e277f2706$var$retrieveAddress(activeResult.dataset.id);
            else findAddresses(activeResult.dataset.id);
        }
    });
    //add keyboard functionality to the address result list
    $c318455e277f2706$var$addressLookup.addEventListener("keydown", function(event) {
        if ([
            "ArrowUp",
            "ArrowDown",
            "Enter"
        ].includes(event.key) == false) return true;
        //
        event.preventDefault();
        //
        var activeResult1 = $c318455e277f2706$var$addressLookupResults.querySelector(".address-lookup-results div.active");
        var nextResult = null;
        if (event.key == "ArrowUp") {
            //
            nextResult = activeResult1 !== null && activeResult1.previousElementSibling !== null ? activeResult1.previousElementSibling : $c318455e277f2706$var$addressLookupResults.querySelector("div:last-child");
            //no active result - make the first item active
            if (activeResult1 !== null) activeResult1.classList.remove("active");
            //make the next item active (this is either the next reult or the first one.)
            nextResult.classList.add("active");
        }
        if (event.key == "ArrowDown") {
            //
            nextResult = activeResult1 !== null && activeResult1.nextElementSibling !== null ? activeResult1.nextElementSibling : $c318455e277f2706$var$addressLookupResults.querySelector("div:first-child");
            //no active result - make the first item active
            if (activeResult1 !== null) activeResult1.classList.remove("active");
            //make the next item active (this is either the next reult or the first one.)
            nextResult.classList.add("active");
        }
        //
        if (nextResult !== null) $c318455e277f2706$var$addressLookupResults.scrollTop = nextResult.offsetTop - nextResult.offsetHeight * 2;
        //
        if (event.key == "Enter") {
            if (activeResult1.dataset.type == "Address") $c318455e277f2706$var$retrieveAddress(activeResult1.dataset.id);
            else findAddresses(activeResult1.dataset.id);
        }
    });
}


//

var $kbC9w = parcelRequire("kbC9w");
//
document.querySelectorAll(".advert").forEach(function(advert) {
    var _advert_dataset;
    //check to see if we could be on a mobile type screen (super janky) - if so - do not show the advert
    if (window.innerWidth < advert.dataset.visibleFrom) return;
    //
    if ($kbC9w.get(advert.dataset.advertName) == "shown") return;
    var _advert_dataset_delay;
    //display the advert after n seconds (default to 10)
    if (advert.dataset.state == "hidden") window.setTimeout(function() {
        advert.setAttribute("data-state", "maximised");
        $kbC9w.set(advert.dataset.advertName, "shown");
    }, (_advert_dataset_delay = (_advert_dataset = advert.dataset) === null || _advert_dataset === void 0 ? void 0 : _advert_dataset.delay) !== null && _advert_dataset_delay !== void 0 ? _advert_dataset_delay : 10000);
    //
    var advertClose = advert.querySelector('button[data-action="close"]');
    if (advertClose !== null) advertClose.addEventListener("click", function(event) {
        advert.parentElement.removeChild(advert);
        navigator.sendBeacon("/api/advert-tracker", JSON.stringify({
            "advert": advert.dataset.advertName,
            "event": "closed"
        }));
    });
    //
    var advertMinimise = advert.querySelector('button[data-action="minimise"]');
    if (advertMinimise !== null) advertMinimise.addEventListener("click", function(event) {
        advert.setAttribute("data-state", "minimised");
    });
    //
    var advertMaximise = advert.querySelector('button[data-action="maximise"]');
    if (advertMaximise !== null) advertMaximise.addEventListener("click", function(event) {
        advert.setAttribute("data-state", "maximised");
    });
});


//find all elements that have the "collapsed" data attribute
var $57194e40570b6224$var$collapsingContainers = document.querySelectorAll("[data-collapsed]");
var $57194e40570b6224$var$_iteratorNormalCompletion = true, $57194e40570b6224$var$_didIteratorError = false, $57194e40570b6224$var$_iteratorError = undefined;
try {
    var $57194e40570b6224$var$_loop = function() {
        var collapsingContainer = $57194e40570b6224$var$_step.value;
        //depending on the current state of the container, open or close it
        collapsingContainer.addEventListener("toggle", function(event) {
            if (collapsingContainer.getAttribute("data-collapsed") === "true") collapsingContainer.dispatchEvent(new Event("open"));
            else collapsingContainer.dispatchEvent(new Event("close"));
        });
        //open the container if it is not already open
        collapsingContainer.addEventListener("open", function(event) {
            //only start the transition if the container is already collapsed
            if (collapsingContainer.getAttribute("data-collapsed") === "true") {
                //get the height of the container's inner content, regardless of its actual size
                var containerHeight = collapsingContainer.scrollHeight;
                //have the container transition to the height of its inner content
                collapsingContainer.style.height = containerHeight + "px";
                //when the next css transition finishes (which should be the one we just triggered)
                collapsingContainer.addEventListener("transitionend", function(e) {
                    //remove this event listener so it only gets triggered once
                    collapsingContainer.removeEventListener("transitionend", arguments.callee);
                    //remove "height" from the container's inline styles, so it can return to its initial value
                    collapsingContainer.style.height = null;
                });
                //mark the container as "currently not collapsed"
                collapsingContainer.setAttribute("data-collapsed", "false");
            }
        });
        //close the container if it is not already close
        collapsingContainer.addEventListener("close", function(event) {
            //only start the transition if the container is not already collapsed
            if (collapsingContainer.getAttribute("data-collapsed") !== "true") {
                //get the height of the container's inner content, regardless of its actual size
                var containerHeight = collapsingContainer.scrollHeight;
                //temporarily disable all css transitions
                var collapsingContainerTransition = collapsingContainer.style.transition;
                collapsingContainer.style.transition = "";
                //on the next frame (as soon as the previous style change has taken effect), explicitly set the container's height to its current pixel height, so we aren't transitioning out of 'auto'
                requestAnimationFrame(function() {
                    //
                    collapsingContainer.style.height = containerHeight + "px";
                    collapsingContainer.style.transition = collapsingContainerTransition;
                    //on the next frame (as soon as the previous style change has taken effect), set the container's height back to 0
                    requestAnimationFrame(function() {
                        collapsingContainer.style.height = "0px";
                    });
                });
                //mark the container as "currently collapsed"
                collapsingContainer.setAttribute("data-collapsed", "true");
            }
        });
    };
    //add an toggle, open and close event listener to them, so we can wait for them to be triggered later
    for(var $57194e40570b6224$var$_iterator = $57194e40570b6224$var$collapsingContainers[Symbol.iterator](), $57194e40570b6224$var$_step; !($57194e40570b6224$var$_iteratorNormalCompletion = ($57194e40570b6224$var$_step = $57194e40570b6224$var$_iterator.next()).done); $57194e40570b6224$var$_iteratorNormalCompletion = true)$57194e40570b6224$var$_loop();
} catch (err) {
    $57194e40570b6224$var$_didIteratorError = true;
    $57194e40570b6224$var$_iteratorError = err;
} finally{
    try {
        if (!$57194e40570b6224$var$_iteratorNormalCompletion && $57194e40570b6224$var$_iterator.return != null) {
            $57194e40570b6224$var$_iterator.return();
        }
    } finally{
        if ($57194e40570b6224$var$_didIteratorError) {
            throw $57194e40570b6224$var$_iteratorError;
        }
    }
}


//calculate the scroll offset top - used to make the page content show below the header + side menu on smaller screens
var $3047b338739d2164$var$calculateScrollMarginTop = function() {
    window.setTimeout(function() {
        //
        var root = document.querySelector(":root");
        //only do this while the viewport is considered "small"
        if (window.innerWidth > parseInt(getComputedStyle(root).getPropertyValue("--small-viewport-width"), 10)) return;
        //
        var offset = document.querySelector(".site-header").clientHeight + document.querySelector(".site-sidebar-wrapper").clientHeight;
        root.style.setProperty("--scroll-margin-top", "".concat(offset, "px"));
    }, 10);
};
//
window.addEventListener("resize", $3047b338739d2164$var$calculateScrollMarginTop);
$3047b338739d2164$var$calculateScrollMarginTop();


//add action to all elements with a "copy to clipboard" action

var $7K4bb = parcelRequire("7K4bb");

var $cX5iq = parcelRequire("cX5iq");
document.querySelectorAll('[data-action="copy-to-clipboard"][data-target]').forEach(function(element) {
    element.addEventListener("click", function() {
        var _ref = (0, $7K4bb._)(function(event) {
            return (0, $cX5iq.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((target = document.querySelector("".concat(element.dataset.target))) !== null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            navigator.clipboard.writeText(target.innerText)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }());
});


//
document.querySelectorAll("summary").forEach(function(element) {
    return element.addEventListener("click", function(event) {
        //
        var detailsElement = event.target.parentElement;
        var contentElement = event.target.nextElementSibling;
        //chrome sometimes has a hiccup and gets stuck.
        if (contentElement.classList.contains("animation")) {
            //so we make sure to remove those classes manually,
            contentElement.classList.remove("animation", "collapsing");
            //enforce a reflow so that collapsing may be animated again,
            element.offsetWidth;
            //and fallback to the default behaviour this time.
            return;
        }
        //
        var onAnimationEnd = function(callback) {
            return contentElement.addEventListener("animationend", callback, {
                once: true
            });
        };
        //request an animation frame to force Safari 16 to actually perform the animation
        requestAnimationFrame(function() {
            return contentElement.classList.add("animation");
        });
        //
        onAnimationEnd(function() {
            return contentElement.classList.remove("animation");
        });
        //
        if (detailsElement.getAttribute("open") !== null) {
            //prevent default collapsing and delay it until the animation has completed
            event.preventDefault();
            //
            contentElement.classList.add("collapsing");
            onAnimationEnd(function() {
                detailsElement.removeAttribute("open");
                contentElement.classList.remove("collapsing");
            });
        }
    });
});


//
var $75991e7f8fdf0980$var$disableOnSubmitForms = document.querySelectorAll("form[data-disable-on-submit]");
var $75991e7f8fdf0980$var$_iteratorNormalCompletion = true, $75991e7f8fdf0980$var$_didIteratorError = false, $75991e7f8fdf0980$var$_iteratorError = undefined;
//
if ($75991e7f8fdf0980$var$disableOnSubmitForms != null && $75991e7f8fdf0980$var$disableOnSubmitForms.length > 0) try {
    var $75991e7f8fdf0980$var$_loop = function() {
        var disableOnSubmitForm = $75991e7f8fdf0980$var$_step.value;
        disableOnSubmitForm.addEventListener("submit", function(event) {
            var submitButtons = disableOnSubmitForm.querySelectorAll('button:not([type="button"]):not([type="reset"])');
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (submitButtons !== null && submitButtons.length > 0) try {
                for(var _iterator = submitButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var submitButton = _step.value;
                    submitButton.setAttribute("disabled", "disabled");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    };
    for(var $75991e7f8fdf0980$var$_iterator = $75991e7f8fdf0980$var$disableOnSubmitForms[Symbol.iterator](), $75991e7f8fdf0980$var$_step; !($75991e7f8fdf0980$var$_iteratorNormalCompletion = ($75991e7f8fdf0980$var$_step = $75991e7f8fdf0980$var$_iterator.next()).done); $75991e7f8fdf0980$var$_iteratorNormalCompletion = true)$75991e7f8fdf0980$var$_loop();
} catch (err) {
    $75991e7f8fdf0980$var$_didIteratorError = true;
    $75991e7f8fdf0980$var$_iteratorError = err;
} finally{
    try {
        if (!$75991e7f8fdf0980$var$_iteratorNormalCompletion && $75991e7f8fdf0980$var$_iterator.return != null) {
            $75991e7f8fdf0980$var$_iterator.return();
        }
    } finally{
        if ($75991e7f8fdf0980$var$_didIteratorError) {
            throw $75991e7f8fdf0980$var$_iteratorError;
        }
    }
}


//listen for any click events on the body tag
document.querySelector("body").addEventListener("click", function(event) {
    //ignore any click events that's are not to an external site
    if (event.target.matches('a[href^="http"]:not([href^="https://www.nrla.org.uk"])')) navigator.sendBeacon("/r/".concat(encodeURIComponent(event.target.getAttribute("href")), "?beacon=yes"));
});


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $lT1Za = parcelRequire("lT1Za");

var $cX5iq = parcelRequire("cX5iq");

var $fZi8Q = parcelRequire("fZi8Q");
//
var $be08434be6d0986b$var$validationTests = {};
//define a whole bunch of regex
var $be08434be6d0986b$var$isEmailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
var $be08434be6d0986b$var$isAlphanumericRegex = /^[A-Za-z0-9]+$/i;
var $be08434be6d0986b$var$isAlphaRegex = /^[A-Za-z]+$/;
var $be08434be6d0986b$var$isUrlRegex = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i;
var $be08434be6d0986b$var$isIPv4Regex = /^(?:(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/;
var $be08434be6d0986b$var$isIPv6Regex = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i;
var $be08434be6d0986b$var$isDateRegex = /^(?:\2)(?:[0-9]{2})?[0-9]{2}([\/-])(1[0-2]|0?[1-9])([\/-])(3[01]|[12][0-9]|0?[1-9])$/;
var $be08434be6d0986b$var$isTimeRegex = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/;
var $be08434be6d0986b$var$isNumberRegex = /^\s*(\+|-)?((\d+(\.\d+)?)|(\.\d+))\s*$/;
var $be08434be6d0986b$var$isPasswordRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{10,}$/;
//apply validation to every form which is built using the form system
document.querySelectorAll("[data-form-validation]").forEach(function(form) {
    //apply the onchange and other events to the fields on the form
    $be08434be6d0986b$var$applyDynamicValidationToFields(form);
    //
    form.addEventListener("submit", function() {
        var _ref = (0, $7K4bb._)(function(event) {
            var validationPassed, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, validation, valueInputFromUser1, thisFieldPassed, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, input1, inputToScrollTo;
            return (0, $cX5iq.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //
                        event.preventDefault();
                        //this is remains true at end if all the fields are validated successfully
                        validationPassed = true;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = form.querySelectorAll(".input-group")[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        input = _step.value;
                        //
                        validation = null;
                        if (!(input.dataset.validation !== undefined && input.querySelector("input, textarea, select option:checked"))) return [
                            3,
                            4
                        ];
                        valueInputFromUser1 = null;
                        validation = JSON.parse(input.dataset.validation);
                        //If the input is a checkbox then validation is based on number of checkboxes checked
                        if (input.querySelector('input[type="checkbox"]')) {
                            valueInputFromUser1 = $be08434be6d0986b$var$getCheckedCount(input);
                            if (valueInputFromUser1 == 0) valueInputFromUser1 = "";
                        } else if (input.querySelector('input[type="radio"]')) {
                            if (input.querySelector('input[type="radio"]:checked') == null) valueInputFromUser1 = "";
                            else valueInputFromUser1 = input.querySelector('input[type="radio"]:checked').value;
                        } else valueInputFromUser1 = input.querySelector("input, textarea, select option:checked").value;
                        return [
                            4,
                            $be08434be6d0986b$var$validateField(validation, valueInputFromUser1, input)
                        ];
                    case 3:
                        thisFieldPassed = _state.sent();
                        //If any field fails to be validated then set validationPassed flag to false
                        if (validationPassed == true && thisFieldPassed == false) validationPassed = false;
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        //If JavaScript validation passes then submit the form.
                        if (validationPassed) {
                            if (typeof form.nrlaSubmitCallback == "function") form.nrlaSubmitCallback();
                            else form.submit();
                        }
                        //scroll to the highest error input field
                        if (validationPassed == false) {
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = form.querySelectorAll(".input-group")[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    input1 = _step1.value;
                                    if (input1.classList.contains("input-error")) {
                                        //
                                        inputToScrollTo = input1;
                                        //get the nearest visible parent element
                                        while(inputToScrollTo.checkVisibility() == false)inputToScrollTo = inputToScrollTo.parentElement;
                                        //
                                        inputToScrollTo.scrollIntoView({
                                            "behavior": "smooth",
                                            "block": "start",
                                            "inline": "nearest"
                                        });
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }());
});
function $be08434be6d0986b$var$validateField(validation, valueInputFromUser1, input) {
    return $be08434be6d0986b$var$_validateField.apply(this, arguments);
}
function $be08434be6d0986b$var$_validateField() {
    $be08434be6d0986b$var$_validateField = /**
 * Function to validate a field returns true if validated
 * @param  object validation            Required - An array of objects with rules and message properties
 * @param  string valueInputFromUser    Required - The value input to the field by the user
 * @param  object input                 Required - Reference to the input element to show error message
 * @return bool
*/ (0, $7K4bb._)(function(validation, valueInputFromUser1, input) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, rule, _document_querySelector, whenField, whenOperator, whenValue, whenFieldValue, tests, isRequiredArray, _this, result, didValueValidate, err;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = validation[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    rule = _step.value;
                    //check when condition (field operator value)
                    if (rule.hasOwnProperty("when")) {
                        //
                        match = rule.when.match(/^(.+?) (==|!=|not in|in|>=|<=|>|<)(?: \(?)?([^\(\)\n]+)(?:\))?$/);
                        //
                        if (match) {
                            ;
                            //
                            whenField = match[1].trim();
                            whenOperator = match[2].trim();
                            whenValue = match[3].trim();
                            //get field value
                            whenFieldValue = (_document_querySelector = document.querySelector('input[name="'.concat(whenField, '"]:not([type="radio"]), input[name="').concat(whenField, '"][type="radio"]:checked, select[name="').concat(whenField, '"], textarea[name="').concat(whenField, '"]'))) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.value;
                            //convert operator to a function
                            operators = {
                                "==": function(a, b) {
                                    return a == b;
                                },
                                "!=": function(a, b) {
                                    return a != b;
                                },
                                ">": function(a, b) {
                                    return a > b;
                                },
                                "<": function(a, b) {
                                    return a < b;
                                },
                                ">=": function(a, b) {
                                    return a >= b;
                                },
                                "<=": function(a, b) {
                                    return a <= b;
                                },
                                "in": function(a, b) {
                                    return b.includes(a);
                                },
                                "not in": function(a, b) {
                                    return !b.includes(a);
                                }
                            };
                            //if the when condition does not match - then skip validation
                            if (operators.hasOwnProperty(whenOperator) && operators[whenOperator](whenFieldValue, whenValue) === false) return [
                                2
                            ];
                        }
                    }
                    //
                    tests = JSON.parse(rule.rules);
                    //if the rule list does not contain is required rule and the value from user is empty then don't show error message.
                    isRequiredArray = tests.filter(function(test) {
                        return test.includes("is_required");
                    });
                    if (isRequiredArray.length == 0 && (valueInputFromUser1 == "" || valueInputFromUser1 == undefined)) return [
                        2,
                        true
                    ];
                    _this = this;
                    return [
                        4,
                        Promise.all(tests.map(function() {
                            var _ref = (0, $7K4bb._)(function(test) {
                                return (0, $cX5iq.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            //if the test is not defined, skip it as it's not been implemented on the client
                                            if (!$be08434be6d0986b$var$validationTests.hasOwnProperty(test[0])) {
                                                console.warn('The test called "'.concat(test[0], '" is not implemented on the client and will be validated on the server only.'));
                                                return [
                                                    2,
                                                    true
                                                ];
                                            }
                                            return [
                                                4,
                                                $be08434be6d0986b$var$validationTests[test[0]].apply(_this, [
                                                    valueInputFromUser1
                                                ].concat((0, $lT1Za._)(test.slice(1))))
                                            ];
                                        case 1:
                                            //
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function(test) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 3:
                    result = _state.sent();
                    //
                    didValueValidate = result.every(function(r) {
                        return r === true;
                    });
                    //show error if the rule fails and set flag to true
                    if (didValueValidate == false) {
                        //
                        input.querySelector(".input-error-message").innerHTML = rule.message;
                        input.classList.add("input-error");
                        //
                        return [
                            2,
                            false
                        ];
                    }
                    //if the input was showing an error before but the new input is valid then remove the error message and styles
                    if (didValueValidate == true && input.classList.contains("input-error")) $be08434be6d0986b$var$removeErrorStyles(input);
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    //
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return $be08434be6d0986b$var$_validateField.apply(this, arguments);
}
/**
 * Add a test to the validation system
 */ function $be08434be6d0986b$var$addValidationTest(name, callback) {
    $be08434be6d0986b$var$validationTests[name] = callback;
}
//define the rules to be used in the validation system
$be08434be6d0986b$var$addValidationTest("is_required", function(input) {
    return !!input;
});
//
$be08434be6d0986b$var$addValidationTest("is_email", function(input) {
    return $be08434be6d0986b$var$isEmailRegex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("isPhoneNumber", function(input) {
    return new RegExp("^[0-9 \\-()+]+$").test(input) && input.replaceAll(/[^0-9]/g, "").length >= 4;
});
//
$be08434be6d0986b$var$addValidationTest("min_length", function(input, min) {
    return typeof input === "string" && input.length >= min;
});
//
$be08434be6d0986b$var$addValidationTest("max_length", function(input, max) {
    return typeof input === "string" && input.length <= max;
});
//
$be08434be6d0986b$var$addValidationTest("min_value", function(input, min) {
    return input >= min;
});
//
$be08434be6d0986b$var$addValidationTest("max_value", function(input, max) {
    return input <= max;
});
//
$be08434be6d0986b$var$addValidationTest("is_alphanumeric", function(input) {
    return $be08434be6d0986b$var$isAlphanumericRegex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("is_alpha", function(input) {
    return $be08434be6d0986b$var$isAlphaRegex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("is_url", function(input) {
    return $be08434be6d0986b$var$isUrlRegex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("is_ipv4", function(input) {
    return $be08434be6d0986b$var$isIPv4Regex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("is_ipv6", function(input) {
    return $be08434be6d0986b$var$isIPv6Regex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("is_date", function(input) {
    //
    if (!$be08434be6d0986b$var$isDateRegex.test(input)) return false;
    //define the valid date range
    var minDate = new Date("1753-01-01");
    var maxDate = new Date("9999-12-31");
    //
    var date = new Date(input);
    //
    return date >= minDate && date <= maxDate;
});
//
$be08434be6d0986b$var$addValidationTest("is_time", function(input) {
    return $be08434be6d0986b$var$isTimeRegex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("is_number", function(input) {
    return $be08434be6d0986b$var$isNumberRegex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("is_password", function(input) {
    return $be08434be6d0986b$var$isPasswordRegex.test(input);
});
//
$be08434be6d0986b$var$addValidationTest("isValidYearOfBirth", function(input) {
    return !isNaN(parseInt(input, 10)) && new Date().getFullYear() - parseInt(input, 10) >= 18 && parseInt(input, 10).toString().length == 4;
});
//
$be08434be6d0986b$var$addValidationTest("is_emailalreadyused", function() {
    var _ref = (0, $7K4bb._)(function(input) {
        var ignoreCurrentUser, _ref, status, response;
        var _arguments = arguments;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ignoreCurrentUser = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                    return [
                        4,
                        $fZi8Q("post", "/api/check-email-already-used", null, {
                            "email": input,
                            ignoreCurrentUser: ignoreCurrentUser
                        })
                    ];
                case 1:
                    _ref = (0, $haqKc._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), status = _ref[0], response = _ref[1];
                    if (status == "success" && response.isEmailAlreadyUsed == true) return [
                        2,
                        false
                    ];
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return function(input) {
        return _ref.apply(this, arguments);
    };
}());
/**
 * Shows an error on the field as its value is changed
 * @param  object form  Required - A reference to the form
 * @return void
*/ function $be08434be6d0986b$var$applyDynamicValidationToFields(form) {
    form.querySelectorAll(".input-group").forEach(function(input) {
        //If validation is not defined there is not input or select in the input group then return immediately
        if (!(input.dataset.validation !== undefined && input.querySelector("input, textarea, select"))) return;
        //only do something now if there is a validation attribute and there is one of the specific elements in the input group
        var validation = JSON.parse(input.dataset.validation);
        var timeOutID = null; //For storing the setTimeout ID
        //used to keep track of the name attribute for element in focus and previous element in focus
        var focusElementNameNow = null;
        var prevFocusedElementName = null;
        //check if the input group is for a checkbox
        if (input.hasAttribute("data-checkbox-group")) {
            var checkboxes = input.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(function(checkbox) {
                //Remove error styles when focus has gained and clear timeout
                checkbox.addEventListener("focusin", function(event) {
                    //
                    focusElementNameNow = checkbox.getAttribute("name");
                    var inputGroup = this.closest(".input-group");
                    //
                    clearTimeout(timeOutID);
                });
                //Try to validate the field after timeout when focus is lost
                checkbox.addEventListener("blur", function(event) {
                    //
                    prevFocusedElementName = checkbox.getAttribute("name");
                    focusElementNameNow = null;
                    valueInputFromUser = $be08434be6d0986b$var$getCheckedCount(input);
                    //if number of checked is 0 then turn into empty string for the is required rule
                    if (valueInputFromUser == 0) valueInputFromUser = "";
                    //
                    var inputGroup = this.closest(".input-group");
                    //Try to validate the field in 500ms only if the new focus element name is different
                    timeOutID = setTimeout(function() {
                        if (prevFocusedElementName != focusElementNameNow) $be08434be6d0986b$var$validateField(validation, valueInputFromUser, inputGroup);
                    }, 500);
                });
            });
            return;
        }
        //if any inputs loose focus, start a timer to validate the input group
        input.querySelectorAll('input:not([type="checkbox"]), textarea, select').forEach(function(element) {
            element.addEventListener("blur", function(event) {
                //
                prevFocusedElementName = this.getAttribute("name");
                focusElementNameNow = null;
                var valueInputFromUser1 = this.value;
                var inputGroup = this.closest(".input-group");
                //Try to validate the field in 500ms
                timeOutID = setTimeout(function() {
                    $be08434be6d0986b$var$validateField(validation, valueInputFromUser1, inputGroup);
                }, 500);
            });
        });
        //if any field in the input group gains focus back, then stop the error validation from triggering
        input.querySelectorAll('input:not([type="checkbox"]), textarea, select').forEach(function(element) {
            element.addEventListener("focus", function(event) {
                focusElementNameNow = this.getAttribute("name");
                clearTimeout(timeOutID);
            });
        });
    });
}
/**
 * Removes the error message error class from the input group
 * @param  object form  Required - Reference to the input-group
 * @return void
*/ function $be08434be6d0986b$var$removeErrorStyles(input) {
    input.querySelector(".input-error-message").textContent = "";
    input.classList.remove("input-error");
}
/**
 * Returns the count of checkboxes checked in the input
 * @param  object input  Required - Reference to the input-group
 * @return int
*/ function $be08434be6d0986b$var$getCheckedCount(checkboxField) {
    var count = 0;
    checkboxField.querySelectorAll(".input-option-label").forEach(function(checkbox) {
        var input = checkbox.querySelector('input[type="checkbox"]');
        if (input.checked) count++;
    });
    return count;
}


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");
var //handle the cookie notification bar
$ef8320fd584f03ba$var$_document_querySelector;

var $fZi8Q = parcelRequire("fZi8Q");

var $k2ek2 = parcelRequire("k2ek2");
($ef8320fd584f03ba$var$_document_querySelector = document.querySelector(".cookie-control-bar")) === null || $ef8320fd584f03ba$var$_document_querySelector === void 0 ? void 0 : $ef8320fd584f03ba$var$_document_querySelector.addEventListener("click", $k2ek2(200, function() {
    var _ref = (0, $7K4bb._)(function(event) {
        var action, _ref, status, _document_querySelector, _document_querySelector1, siteHeaderOffset, siteSidebarOffset;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    //
                    action = event.target.getAttribute("data-action");
                    if (!(action === "accept-cookies" || action === "reject-cookies")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $fZi8Q("post", "/cookie.php", null, {
                            action: action
                        })
                    ];
                case 1:
                    _ref = (0, $haqKc._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), status = _ref[0];
                    if (status == "success") {
                        ;
                        //hide the cookie bar
                        document.querySelector(".cookie-control-bar").style.display = "none";
                        //recompute the header offset (needed for proper functioning of the header (on small viewports))
                        siteHeaderOffset = (_document_querySelector = document.querySelector(".site-header")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getBoundingClientRect().bottom;
                        document.body.style.setProperty("--header-offset", "".concat(siteHeaderOffset, "px"));
                        //recompute the sidebar offset (needed for proper functioning of the header (on small viewports))
                        siteSidebarOffset = (_document_querySelector1 = document.querySelector(".site-sidebar")) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.getBoundingClientRect().bottom;
                        document.body.style.setProperty("--scroll-margin-top", "".concat(siteSidebarOffset, "px"));
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function(event) {
        return _ref.apply(this, arguments);
    };
}()));


//
var $5b09c3fb4fc1dd86$var$siteHeader = document.querySelector(".site-header");
var $5b09c3fb4fc1dd86$var$siteHeaderNavigation = $5b09c3fb4fc1dd86$var$siteHeader.querySelector("nav");
var $5b09c3fb4fc1dd86$var$siteHeaderMenuContainer = $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelector(".navigation-drawer-container");
//
if ($5b09c3fb4fc1dd86$var$siteHeader !== null && $5b09c3fb4fc1dd86$var$siteHeaderNavigation !== null) {
    var $5b09c3fb4fc1dd86$var$queueAction = //
    function queueAction(action) {
        if ($5b09c3fb4fc1dd86$var$currentAction == null) {
            $5b09c3fb4fc1dd86$var$currentAction = action;
            processQueue();
        } else $5b09c3fb4fc1dd86$var$nextAction = action;
    };
    var //------------------------------------------------------------------------------
    //add an interaction to the menu-button to open the "small viewport" menu
    $5b09c3fb4fc1dd86$var$_siteHeader_querySelector, //------------------------------------------------------------------------------
    //open the search menu
    $5b09c3fb4fc1dd86$var$_siteHeader_querySelector1, //close the search menu
    $5b09c3fb4fc1dd86$var$_siteHeader_querySelector2;
    //------------------------------------------------------------------------------
    //add either "scroll-end" or "scroll-start" to the body element based on the direction of the user's scrolling (this will be used to apply scroll based reveals to the header and sidebar)
    var $5b09c3fb4fc1dd86$var$lastScroll = 0;
    var $5b09c3fb4fc1dd86$var$lastScrollOffset = 0;
    //
    window.addEventListener("scroll", function() {
        //
        if (window.scrollY <= 0) {
            document.body.classList.remove("scroll-start");
            return;
        }
        //
        if (window.scrollY > $5b09c3fb4fc1dd86$var$lastScroll && !document.body.classList.contains("scroll-end")) {
            document.body.classList.remove("scroll-start");
            document.body.classList.add("scroll-end");
        } else if (window.scrollY < $5b09c3fb4fc1dd86$var$lastScroll && document.body.classList.contains("scroll-end")) {
            document.body.classList.remove("scroll-end");
            document.body.classList.add("scroll-start");
        }
        //
        if (document.body.classList.contains("scroll-start")) $5b09c3fb4fc1dd86$var$lastScrollOffset = window.scrollY;
        //
        document.body.style.setProperty("--scroll-offset", "".concat((window.scrollY - $5b09c3fb4fc1dd86$var$lastScrollOffset) * -1, "px"));
        //
        $5b09c3fb4fc1dd86$var$lastScroll = window.scrollY;
    });
    //
    window.addEventListener("resize", function() {
        document.body.style.setProperty("--header-offset", "".concat($5b09c3fb4fc1dd86$var$siteHeader.getBoundingClientRect().height, "px"));
    });
    //
    document.body.style.setProperty("--header-offset", "".concat($5b09c3fb4fc1dd86$var$siteHeader.getBoundingClientRect().height, "px"));
    ($5b09c3fb4fc1dd86$var$_siteHeader_querySelector = $5b09c3fb4fc1dd86$var$siteHeader.querySelector('[data-action="open-navigation"]')) === null || $5b09c3fb4fc1dd86$var$_siteHeader_querySelector === void 0 ? void 0 : $5b09c3fb4fc1dd86$var$_siteHeader_querySelector.addEventListener("click", function() {
        //
        $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelectorAll("[data-open]").forEach(function(item) {
            item.removeAttribute("data-open");
        });
        //
        $5b09c3fb4fc1dd86$var$siteHeader.toggleAttribute("data-menu-open");
    });
    //
    $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelectorAll(".navigation-item[data-target]").forEach(function(item) {
        item.addEventListener("click", function(event) {
            if ($5b09c3fb4fc1dd86$var$siteHeader.hasAttribute("data-menu-open")) {
                item.toggleAttribute("data-open");
                $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelector('.navigation-drawer[data-name="'.concat(item.dataset.target, '"]')).toggleAttribute("data-open");
            }
        });
    });
    //------------------------------------------------------------------------------
    //how long does the user need to linger over a menu item to trigger it to open
    var $5b09c3fb4fc1dd86$var$MENU_OPEN_DELAY = 200;
    //track the timer for opening the main menu
    var $5b09c3fb4fc1dd86$var$openMenuTimer = null;
    //
    var $5b09c3fb4fc1dd86$var$isMenuOpen = false;
    var $5b09c3fb4fc1dd86$var$isOpenMenuSticky = false;
    //
    var $5b09c3fb4fc1dd86$var$currentAction = null;
    var $5b09c3fb4fc1dd86$var$nextAction = null;
    //
    function processQueue() {
        //
        if ($5b09c3fb4fc1dd86$var$currentAction.action == "open") {
            //
            var menuToOpen = $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelector('.navigation-drawer[data-name="'.concat($5b09c3fb4fc1dd86$var$currentAction.menu, '"]'));
            //
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.classList.remove("closing");
            //
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.classList.toggle("opening", !$5b09c3fb4fc1dd86$var$isMenuOpen);
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.classList.toggle("open", $5b09c3fb4fc1dd86$var$isMenuOpen);
            //
            $5b09c3fb4fc1dd86$var$siteHeaderMenuContainer.style.height = "".concat(menuToOpen.getBoundingClientRect().height, "px");
            //
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelectorAll(".navigation-drawer.fadein").forEach(function(element) {
                element.classList.remove("fadein");
            });
            //
            menuToOpen.classList.add("fadein");
            //
            $5b09c3fb4fc1dd86$var$isMenuOpen = true;
        }
        //
        if ($5b09c3fb4fc1dd86$var$currentAction.action == "close") {
            //
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.classList.remove("opening");
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.classList.remove("open");
            //
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.classList.add("closing");
            //
            $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelectorAll(".navigation-drawer.fadein").forEach(function(element) {
                element.classList.remove("fadein");
            });
            //
            $5b09c3fb4fc1dd86$var$siteHeaderMenuContainer.style.height = "0rem";
            //
            $5b09c3fb4fc1dd86$var$isMenuOpen = false;
            //
            $5b09c3fb4fc1dd86$var$isOpenMenuSticky = false;
        }
        //
        window.setTimeout(function() {
            //
            $5b09c3fb4fc1dd86$var$currentAction = $5b09c3fb4fc1dd86$var$nextAction;
            $5b09c3fb4fc1dd86$var$nextAction;
            //
            if ($5b09c3fb4fc1dd86$var$currentAction !== null) processQueue();
        }, window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true ? 0 : 500);
    }
    ($5b09c3fb4fc1dd86$var$_siteHeader_querySelector1 = $5b09c3fb4fc1dd86$var$siteHeader.querySelector('[data-action="open-search"]')) === null || $5b09c3fb4fc1dd86$var$_siteHeader_querySelector1 === void 0 ? void 0 : $5b09c3fb4fc1dd86$var$_siteHeader_querySelector1.addEventListener("click", function() {
        if (!$5b09c3fb4fc1dd86$var$siteHeader.hasAttribute("data-menu-open")) {
            //if the search menu is alredy open - treat the as a toggle
            if ($5b09c3fb4fc1dd86$var$siteHeaderMenuContainer.querySelector('.navigation-drawer[data-name="search"]').classList.contains("fadein")) {
                $5b09c3fb4fc1dd86$var$queueAction({
                    "action": "close"
                });
                return;
            }
            //
            $5b09c3fb4fc1dd86$var$queueAction({
                "action": "open",
                "menu": "search"
            });
            $5b09c3fb4fc1dd86$var$isOpenMenuSticky = true;
        }
    });
    ($5b09c3fb4fc1dd86$var$_siteHeader_querySelector2 = $5b09c3fb4fc1dd86$var$siteHeader.querySelector('[data-action="close-search"]')) === null || $5b09c3fb4fc1dd86$var$_siteHeader_querySelector2 === void 0 ? void 0 : $5b09c3fb4fc1dd86$var$_siteHeader_querySelector2.addEventListener("click", function() {
        if (!$5b09c3fb4fc1dd86$var$siteHeader.hasAttribute("data-menu-open")) $5b09c3fb4fc1dd86$var$queueAction({
            "action": "close"
        });
    });
    //------------------------------------------------------------------------------
    //add mouse events to open the menu
    $5b09c3fb4fc1dd86$var$siteHeaderNavigation.querySelectorAll(".navigation-item[data-target]").forEach(function(item) {
        //
        item.addEventListener("mouseenter", function(event) {
            if ($5b09c3fb4fc1dd86$var$siteHeader.hasAttribute("data-menu-open")) return;
            //
            if ($5b09c3fb4fc1dd86$var$isOpenMenuSticky == true) return;
            //if the menu is already open - do not delay - just go for it (as the queue will handle any mess)
            if ($5b09c3fb4fc1dd86$var$isMenuOpen) {
                $5b09c3fb4fc1dd86$var$queueAction({
                    "action": "open",
                    "menu": event.target.dataset.target
                });
                return;
            }
            //
            $5b09c3fb4fc1dd86$var$openMenuTimer = window.setTimeout(function() {
                $5b09c3fb4fc1dd86$var$queueAction({
                    "action": "open",
                    "menu": event.target.dataset.target
                });
            }, $5b09c3fb4fc1dd86$var$MENU_OPEN_DELAY);
        });
        //
        item.addEventListener("mouseleave", function(event) {
            window.clearTimeout($5b09c3fb4fc1dd86$var$openMenuTimer);
        });
    });
    //
    document.querySelector("body").addEventListener("mouseover", function(event) {
        //
        if ($5b09c3fb4fc1dd86$var$isMenuOpen == false || $5b09c3fb4fc1dd86$var$isOpenMenuSticky == true) return;
        //
        var eventTarget = event.target;
        //move up the dom tree to check if the target or any of its parents match the selector (replicating the way jquery .on() works)
        while(eventTarget){
            if (eventTarget.matches(".site-header nav")) {
                event.stopPropagation();
                return;
            }
            eventTarget = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.parentElement;
        }
        //
        $5b09c3fb4fc1dd86$var$queueAction({
            "action": "close"
        });
    });
//------------------------------------------------------------------------------
}


//

var $70P4J = parcelRequire("70P4J");
//
var $0e70737bc6b47853$var$captchaProtectedForms = document.querySelectorAll("form[data-captcha-site-key]");
//if there any forms wanting a captcha - then load the js
if ($0e70737bc6b47853$var$captchaProtectedForms != null && $0e70737bc6b47853$var$captchaProtectedForms.length > 0) {
    //start loading the captcha api
    var $0e70737bc6b47853$var$captchaScript = $70P4J("script", {
        "src": "https://www.google.com/recaptcha/api.js?onload=ongReCaptchaLoaded&render=explicit",
        "async": "async",
        "defer": "defer"
    });
    document.querySelector("head").append($0e70737bc6b47853$var$captchaScript);
    var $0e70737bc6b47853$var$_iteratorNormalCompletion = true, $0e70737bc6b47853$var$_didIteratorError = false, $0e70737bc6b47853$var$_iteratorError = undefined;
    try {
        //lets disable the buttons on the forms until the captcha is collected
        for(var $0e70737bc6b47853$var$_iterator = $0e70737bc6b47853$var$captchaProtectedForms[Symbol.iterator](), $0e70737bc6b47853$var$_step; !($0e70737bc6b47853$var$_iteratorNormalCompletion = ($0e70737bc6b47853$var$_step = $0e70737bc6b47853$var$_iterator.next()).done); $0e70737bc6b47853$var$_iteratorNormalCompletion = true){
            var $0e70737bc6b47853$var$captchaProtectedForm = $0e70737bc6b47853$var$_step.value;
            $0e70737bc6b47853$var$captchaProtectedForm.querySelector('button:not([type="button"])').setAttribute("disabled", "disabled");
        }
    } catch (err) {
        $0e70737bc6b47853$var$_didIteratorError = true;
        $0e70737bc6b47853$var$_iteratorError = err;
    } finally{
        try {
            if (!$0e70737bc6b47853$var$_iteratorNormalCompletion && $0e70737bc6b47853$var$_iterator.return != null) {
                $0e70737bc6b47853$var$_iterator.return();
            }
        } finally{
            if ($0e70737bc6b47853$var$_didIteratorError) {
                throw $0e70737bc6b47853$var$_iteratorError;
            }
        }
    }
    //
    window.ongReCaptchaLoaded = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var captchaProtectedForm = _step.value;
                //render the captcha element so we can get the user to press it
                var grecaptchaContainer = $70P4J("div", {
                    "class": "form-captcha"
                });
                //
                if (typeof captchaProtectedForm.dataset.captchaHidden !== "undefined") {
                    grecaptchaContainer.classList.add("hidden");
                    captchaProtectedForm.addEventListener("input", function(event) {
                        grecaptchaContainer.classList.remove("hidden");
                    });
                }
                //
                captchaProtectedForm.querySelector(".form-controls").prepend(grecaptchaContainer);
                //
                grecaptcha.render(grecaptchaContainer, {
                    "sitekey": captchaProtectedForm.dataset.captchaSiteKey,
                    "callback": function(response) {
                        //
                        captchaProtectedForm.appendChild($70P4J("input", {
                            "type": "hidden",
                            "name": "captchaToken",
                            "value": response
                        }));
                        //
                        captchaProtectedForm.querySelector('button:not([type="button"])').removeAttribute("disabled");
                    }
                });
            };
            //
            for(var _iterator = $0e70737bc6b47853$var$captchaProtectedForms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}


//
var $d6cafad139eb4aa6$var$siteSidebar = document.querySelector(".site-sidebar");

//
if ($d6cafad139eb4aa6$var$siteSidebar !== null) {
    //
    var $d6cafad139eb4aa6$var$details = $d6cafad139eb4aa6$var$siteSidebar.querySelectorAll("details");
    //
    var $d6cafad139eb4aa6$var$smallViewportSize = parseInt(getComputedStyle(document.querySelector(":root")).getPropertyValue("--small-viewport-width"), 10);
    //
    var $d6cafad139eb4aa6$var$isInSmallViewportMode = false;
    //
    var $d6cafad139eb4aa6$var$toggleOpenAttribute = function() {
        //moving from small to large viewport
        if ($d6cafad139eb4aa6$var$isInSmallViewportMode && window.innerWidth > $d6cafad139eb4aa6$var$smallViewportSize) {
            //force open the menus
            $d6cafad139eb4aa6$var$details.forEach(function(detail) {
                return detail.setAttribute("open", "open");
            });
            //
            $d6cafad139eb4aa6$var$isInSmallViewportMode = false;
        }
        //moving from large to small
        if (!$d6cafad139eb4aa6$var$isInSmallViewportMode && window.innerWidth < $d6cafad139eb4aa6$var$smallViewportSize) {
            //force all the menus to be closed
            $d6cafad139eb4aa6$var$details.forEach(function(detail) {
                return detail.removeAttribute("open");
            });
            //
            $d6cafad139eb4aa6$var$isInSmallViewportMode = true;
        }
    };
    //
    window.addEventListener("resize", $d6cafad139eb4aa6$var$toggleOpenAttribute);
    $d6cafad139eb4aa6$var$toggleOpenAttribute();
    //close the other menus
    $d6cafad139eb4aa6$var$siteSidebar.querySelectorAll("summary.heading").forEach(function(summary) {
        summary.addEventListener("click", function(event) {
            if ($d6cafad139eb4aa6$var$isInSmallViewportMode && !event.target.parentElement.open) $d6cafad139eb4aa6$var$details.forEach(function(detail) {
                if (detail !== event.target.parentElement) detail.removeAttribute("open");
            });
        });
    });
    //close all the menu's when a click hits the body (unless it went through the sidebar)
    document.querySelector("body").addEventListener("click", function(event) {
        //
        if (!$d6cafad139eb4aa6$var$isInSmallViewportMode) return;
        //
        var eventTarget = event.target;
        //move up the dom tree to check if the target or any of its parents match the selector (replicating the way jquery .on() works)
        while(eventTarget){
            if (eventTarget.matches(".site-sidebar-wrapper")) {
                event.stopPropagation();
                return;
            }
            eventTarget = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.parentElement;
        }
        //
        $d6cafad139eb4aa6$var$details.forEach(function(detail) {
            detail.removeAttribute("open");
        });
    });
    //close the menu when the user navigates to an option
    $d6cafad139eb4aa6$var$siteSidebar.querySelectorAll("a").forEach(function(link) {
        link.addEventListener("click", function() {
            if ($d6cafad139eb4aa6$var$isInSmallViewportMode) $d6cafad139eb4aa6$var$details.forEach(function(detail) {
                detail.removeAttribute("open");
            });
        });
    });
    //
    var $d6cafad139eb4aa6$var$ScrollSpy = (parcelRequire("03Gk5"));
    //
    var $d6cafad139eb4aa6$var$sidebarScrollSpy = new $d6cafad139eb4aa6$var$ScrollSpy(".site-sidebar ul li", ".container-column a[name]");
    $d6cafad139eb4aa6$var$sidebarScrollSpy.enableSmoothScroll();
}


var $203644b57541a629$var$swapItems = document.querySelectorAll("[data-swap]");
$203644b57541a629$var$swapItems.forEach(function(swapItem) {
    //get the data ids of the items to hide and show
    var hideElementID = swapItem.dataset.swapHide;
    var showElementID = swapItem.dataset.swapShow;
    swapItem.addEventListener("click", function(event) {
        var _showElement_dataset;
        //
        event.preventDefault();
        //
        var hideElement = document.querySelector('[data-swap-id="' + hideElementID + '"]');
        var showElement = document.querySelector('[data-swap-id="' + showElementID + '"]');
        //
        hideElement.style.display = "none";
        var _showElement_dataset_swapDisplay;
        showElement.style.display = (_showElement_dataset_swapDisplay = showElement === null || showElement === void 0 ? void 0 : (_showElement_dataset = showElement.dataset) === null || _showElement_dataset === void 0 ? void 0 : _showElement_dataset.swapDisplay) !== null && _showElement_dataset_swapDisplay !== void 0 ? _showElement_dataset_swapDisplay : "block";
    });
});


//

var $7K4bb = parcelRequire("7K4bb");

var $cX5iq = parcelRequire("cX5iq");

var $cEi7m = parcelRequire("cEi7m");
//
var $4b115d0584b57664$var$wysiwygItemsSimple = document.querySelectorAll('[data-wysiwyg="simple"]');
var $4b115d0584b57664$var$wysiwygItemsAdvanced = document.querySelectorAll('[data-wysiwyg="full"]');
var $4b115d0584b57664$var$wysiwygItemsCustom = document.querySelectorAll('[data-wysiwyg="custom"]');
//
(0, $7K4bb._)(function() {
    return (0, $cX5iq.__generator)(this, function(_state) {
        //
        $4b115d0584b57664$var$wysiwygItemsSimple.forEach(function(wysiwygItem) {
            $cEi7m.createSimpleContentEditor(wysiwygItem);
        });
        //
        $4b115d0584b57664$var$wysiwygItemsAdvanced.forEach(function(wysiwygItem) {
            $cEi7m.createFullContentEditor(wysiwygItem);
        });
        //
        $4b115d0584b57664$var$wysiwygItemsCustom.forEach(function(wysiwygItem) {
            var _wysiwygItem_dataset;
            var _wysiwygItem_dataset_wysiwygButtons;
            $cEi7m.createCustomContentEditor(wysiwygItem, JSON.parse((_wysiwygItem_dataset_wysiwygButtons = (_wysiwygItem_dataset = wysiwygItem.dataset) === null || _wysiwygItem_dataset === void 0 ? void 0 : _wysiwygItem_dataset.wysiwygButtons) !== null && _wysiwygItem_dataset_wysiwygButtons !== void 0 ? _wysiwygItem_dataset_wysiwygButtons : "{}"));
        });
        return [
            2
        ];
    });
})();


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");
var $066cf7e536514be9$var$searchResultsContainer = document.querySelector('div[data-name="search-results-container"]');



//
if ($066cf7e536514be9$var$searchResultsContainer !== null) {
    var $066cf7e536514be9$var$loadNewResults = function loadNewResults() {
        return _loadNewResults.apply(this, arguments);
    };
    var $066cf7e536514be9$var$loadNewSearch = function loadNewSearch(captcha) {
        return _loadNewSearch.apply(this, arguments);
    };
    //
    var $066cf7e536514be9$var$zenoFetch = (parcelRequire("fZi8Q"));
    var $066cf7e536514be9$var$renderTemplate = (parcelRequire("dVE5d"));
    var $066cf7e536514be9$var$grecaptcha = (parcelRequire("dRAC6"));
    //
    var $066cf7e536514be9$var$search = $066cf7e536514be9$var$searchResultsContainer.getAttribute("data-search-term");
    var $066cf7e536514be9$var$facet = $066cf7e536514be9$var$searchResultsContainer.getAttribute("data-facet");
    //
    var $066cf7e536514be9$var$page = Number($066cf7e536514be9$var$searchResultsContainer.getAttribute("data-current-page"));
    //
    $066cf7e536514be9$var$searchResultsContainer.addEventListener("click", function(event) {
        //
        if (event.target.matches("a[data-page], i.fa-solid.fa-chevron-right, i.fa-solid.fa-chevron-left")) {
            //
            element = event.target.closest("a[data-page]");
            //
            event.preventDefault();
            //
            $066cf7e536514be9$var$page = element.getAttribute("data-page");
            $066cf7e536514be9$var$searchResultsContainer.setAttribute("data-current-page", $066cf7e536514be9$var$page);
            //
            $066cf7e536514be9$var$loadNewResults();
        }
        //
        if (event.target.matches("a[data-facet-name]")) {
            //
            event.preventDefault();
            //
            $066cf7e536514be9$var$facet = "".concat(event.target.getAttribute("data-facet-category"), ":").concat(event.target.getAttribute("data-facet-name"));
            $066cf7e536514be9$var$page = 1;
            //
            $066cf7e536514be9$var$searchResultsContainer.setAttribute("data-current-page", 1);
            $066cf7e536514be9$var$searchResultsContainer.setAttribute("data-facet", $066cf7e536514be9$var$facet);
            //
            $066cf7e536514be9$var$loadNewResults();
        }
        //
        if (event.target.matches('i[data-action="show-less"]')) event.target.closest(".facet-category").removeAttribute("data-expanded");
        //
        if (event.target.matches('i[data-action="show-more"]')) event.target.closest(".facet-category").setAttribute("data-expanded", "data-expanded");
        //
        if (event.target.matches('[data-action="hide-facets"]')) event.target.closest(".facets").removeAttribute("data-expanded");
        //
        if (event.target.matches('[data-action="show-facets"]')) event.target.closest(".facets").setAttribute("data-expanded", "data-expanded");
        //
        if (event.target.matches('[data-action="reset-facets"]')) {
            //
            event.preventDefault();
            //
            $066cf7e536514be9$var$facet = "";
            //
            $066cf7e536514be9$var$page = 1;
            $066cf7e536514be9$var$searchResultsContainer.setAttribute("data-current-page", $066cf7e536514be9$var$page);
            $066cf7e536514be9$var$searchResultsContainer.setAttribute("data-facet", $066cf7e536514be9$var$facet);
            //
            $066cf7e536514be9$var$loadNewResults();
        }
        //
        if (event.target.matches(".search-result a")) {
            //
            var formData = new FormData();
            //
            formData.append("eventName", "Link Clicked");
            formData.append("objectID", event.target.dataset.objectId);
            formData.append("position", parseInt(event.target.dataset.position, 10));
            formData.append("queryID", $066cf7e536514be9$var$searchResultsContainer.getAttribute("data-query-id"));
            //
            navigator.sendBeacon("/api/send-algolia-event", formData);
        }
    });
    //
    if ($066cf7e536514be9$var$searchResultsContainer.querySelector('input[name="grecaptcha"]')) $066cf7e536514be9$var$grecaptcha($066cf7e536514be9$var$searchResultsContainer.querySelector('input[name="grecaptcha"]'), function(response) {
        $066cf7e536514be9$var$loadNewSearch(response);
    });
    function _loadNewResults() {
        _loadNewResults = //
        (0, $7K4bb._)(function() {
            var _ref, status, response;
            return (0, $cX5iq.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $066cf7e536514be9$var$zenoFetch("post", "/api/get-search-results", {}, {
                                search: $066cf7e536514be9$var$search,
                                page: $066cf7e536514be9$var$page,
                                facet: $066cf7e536514be9$var$facet
                            })
                        ];
                    case 1:
                        _ref = (0, $haqKc._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), status = _ref[0], response = _ref[1];
                        //
                        if (status === "success") document.querySelector('div[data-name="results"]').innerHTML = $066cf7e536514be9$var$renderTemplate("tpl-search-results", response);
                        return [
                            2
                        ];
                }
            });
        });
        return _loadNewResults.apply(this, arguments);
    }
    function _loadNewSearch() {
        _loadNewSearch = //
        (0, $7K4bb._)(function(captcha) {
            var _ref, status, response;
            return (0, $cX5iq.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $066cf7e536514be9$var$zenoFetch("post", "/api/get-search-results", {}, {
                                search: $066cf7e536514be9$var$search,
                                page: $066cf7e536514be9$var$page,
                                facet: $066cf7e536514be9$var$facet,
                                "captcha": captcha
                            })
                        ];
                    case 1:
                        _ref = (0, $haqKc._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), status = _ref[0], response = _ref[1];
                        //
                        if (status === "success") {
                            //hide the captcha
                            document.querySelector('div[data-name="grecaptcha"]').setAttribute("hidden", true);
                            //display the results and facets
                            document.querySelector('div[data-name="results"]').removeAttribute("hidden");
                            document.querySelector('div[data-name="facets"]').removeAttribute("hidden");
                            //update the results + facets list
                            document.querySelector('div[data-name="results"]').innerHTML = $066cf7e536514be9$var$renderTemplate("tpl-search-results", response);
                            document.querySelector('div[data-name="facets"]').innerHTML = $066cf7e536514be9$var$renderTemplate("tpl-facet-results", response);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _loadNewSearch.apply(this, arguments);
    }
}


//
var $45472e421639ed67$var$cardGridItems = document.querySelectorAll(".card-grid-container");
//
$45472e421639ed67$var$cardGridItems.forEach(function(cardGridItem) {
    cardGridItem.addEventListener("click", function(event) {
        if (event.target.matches(".card-grid-item, .card-grid-item *")) {
            if (event.target.matches(".card-grid-item")) event.target.classList.toggle("card-grid-active");
            else event.target.closest(".card-grid-item").classList.toggle("card-grid-active");
        }
    });
});


//
var $be859bfe09d3cae0$var$domnaHomeServiceEnquiryForm = document.querySelector("#domna-home-service-enquiry-form");
//
if ($be859bfe09d3cae0$var$domnaHomeServiceEnquiryForm !== null) {
    //
    var $be859bfe09d3cae0$var$script = document.createElement("script");
    //
    $be859bfe09d3cae0$var$script.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
    //
    $be859bfe09d3cae0$var$script.onload = function() {
        if (window.hbspt) window.hbspt.forms.create({
            //
            "region": "eu1",
            "portalId": "145275138",
            "formId": "51b3a12d-fbf6-43f7-aced-11dda91c1e4b",
            "target": "#domna-home-service-enquiry-form",
            //
            onFormReady: function onFormReady(form) {
                //
                var hiddenInput = form[0].querySelector('input[name="nrla_membership_id"]');
                var membershipNumber = $be859bfe09d3cae0$var$domnaHomeServiceEnquiryForm.dataset.membershipNumber;
                //
                if (hiddenInput && membershipNumber) {
                    hiddenInput.value = membershipNumber;
                    hiddenInput.dispatchEvent(new Event("change"));
                }
            }
        });
    };
    //
    document.body.appendChild($be859bfe09d3cae0$var$script);
}


//
var $a5055764a6c63437$var$domnaHomeServiceProductForm = document.querySelector("#domna-home-service-product-form");
//
if ($a5055764a6c63437$var$domnaHomeServiceProductForm !== null) {
    //
    var $a5055764a6c63437$var$membershipNumber = $a5055764a6c63437$var$domnaHomeServiceProductForm.dataset.membershipNumber;
    //
    var $a5055764a6c63437$var$script = document.createElement("script");
    //
    $a5055764a6c63437$var$script.src = "https://form.jotform.com/jsform/242354918474060?nrlaMembership=".concat(encodeURIComponent($a5055764a6c63437$var$membershipNumber));
    //
    $a5055764a6c63437$var$script.async = true;
    //
    $a5055764a6c63437$var$domnaHomeServiceProductForm.appendChild($a5055764a6c63437$var$script);
}


//
document.querySelectorAll(".slideshow-container").forEach(function(slider) {
    var startAutoplay = //
    function startAutoplay() {
        timeOutID = setInterval(function() {
            showSlides(slideIndex += 1, slider);
        }, interval);
    };
    var showSlides = //
    function showSlides(n, slider) {
        //
        var i;
        var slides = slider.getElementsByClassName("slide");
        var dots = slider.getElementsByClassName("dot");
        //
        if (n > slides.length) slideIndex = 1;
        //
        if (n < 1) slideIndex = slides.length;
        //
        for(i = 0; i < slides.length; i++)slides[i].style.display = "none";
        //
        for(i = 0; i < dots.length; i++)dots[i].classList.remove("active");
        //
        slides[slideIndex - 1].style.display = "flex";
        //attempt to set the active dot if there are dots on the slider
        if (dots.length > 0) dots[slideIndex - 1].classList.add("active");
        //updating the color for the controls on the current slide
        var controlsColor = slides[slideIndex - 1].dataset.controlsColor;
        var activeDotColor = slides[slideIndex - 1].dataset.activeDotColor;
        //
        slider.style.setProperty("--controlsColor", controlsColor);
        slider.style.setProperty("--dotActiveColor", activeDotColor);
    };
    //
    var slideIndex = 1;
    var timeOutID = null;
    var prevButton = slider.querySelector(".prev");
    var nextButton = slider.querySelector(".next");
    var dots = slider.querySelectorAll(".dot");
    var autoplay = slider.dataset.sliderAutoplay;
    var interval = slider.dataset.sliderInterval * 1000;
    //display the controls (these are hidden on the off chance this js doesn't load)
    slider.querySelector(".slide-pagination").style.display = "flex";
    //
    showSlides(slideIndex, slider);
    //
    slider.querySelectorAll(".slide").forEach(function(slide) {
        //
        if (slide.querySelector(".slide-background-video video") == null) return;
        //
        var video = slide.querySelector(".slide-background-video video");
        var videoSource = slide.querySelector('.slide-background-video video source[type="video/mp4"]');
        //these need to be initialised only if there is a video
        var videoSources = JSON.parse(video.dataset.sources);
        //watch for the video element being resized
        var resizeObserver = new ResizeObserver(function(entries) {
            for(var i = 0; i < videoSources.length; i++)if (entries[0].contentBoxSize[0].inlineSize <= videoSources[i][0] || videoSources.length - 1 == i) {
                //don't reload the video if it's already the loaded one
                if (new URL(videoSource.src).pathname == new URL(videoSources[i][1], "https://www.nrla.org.uk").pathname) break;
                //
                videoSource.src = videoSources[i][1];
                video.load();
                break;
            }
        });
        //
        resizeObserver.observe(video);
    });
    //
    if (autoplay == 1) startAutoplay();
    //
    if (prevButton !== null) prevButton.addEventListener("click", function(event) {
        event.preventDefault();
        showSlides(slideIndex += -1, slider);
        if (autoplay == 1) {
            clearInterval(timeOutID);
            startAutoplay();
        }
    });
    //
    if (nextButton !== null) nextButton.addEventListener("click", function(event) {
        event.preventDefault();
        showSlides(slideIndex += 1, slider);
        if (autoplay == 1) {
            clearInterval(timeOutID);
            startAutoplay();
        }
    });
    // Add click event listener to each dot
    dots.forEach(function(dot, index) {
        dot.addEventListener("click", function(event) {
            event.preventDefault();
            showSlides(slideIndex = index + 1, slider);
            if (autoplay == 1) {
                clearInterval(timeOutID);
                startAutoplay();
            }
        });
    });
});


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");

document.querySelectorAll('div[data-name="ikea-service-information"]').forEach(function(element) {
    //
    element.querySelector('button[data-action="show-interest-form"]').addEventListener("click", function(event) {
        element.querySelector('[data-name="confirm"]').toggleAttribute("hidden");
    });
    //
    element.querySelector('button[data-action="request-callback"]').addEventListener("click", function() {
        var _ref = (0, $7K4bb._)(function(event) {
            var zenoFetch, _ref, status, response;
            return (0, $cX5iq.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //
                        zenoFetch = (parcelRequire("fZi8Q"));
                        return [
                            4,
                            zenoFetch("post", "/api/request-ikea-callback")
                        ];
                    case 1:
                        _ref = (0, $haqKc._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), status = _ref[0], response = _ref[1];
                        //
                        if (status == "success") element.querySelector('[data-name="callback-request-successful"]').removeAttribute("hidden");
                        else element.querySelector('[data-name="callback-request-failed"]').removeAttribute("hidden");
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }());
});


//

var $7K4bb = parcelRequire("7K4bb");

var $cX5iq = parcelRequire("cX5iq");
var $6eb1cd88114a8aac$var$joinPageHeroElement = document.querySelector(".join-page-hero");
var $6eb1cd88114a8aac$var$joinPageHeroContentElement = document.querySelector(".join-page-hero-content");
var $6eb1cd88114a8aac$var$joinPageHeroPromotionElement = document.querySelector(".join-page-promotion-runner");
//
if ($6eb1cd88114a8aac$var$joinPageHeroElement !== null && $6eb1cd88114a8aac$var$joinPageHeroContentElement !== null) {
    var $6eb1cd88114a8aac$var$observer = new ResizeObserver(function(entries) {
        requestAnimationFrame(/*#__PURE__*/ (0, $7K4bb._)(function() {
            return (0, $cX5iq.__generator)(this, function(_state) {
                $6eb1cd88114a8aac$var$joinPageHeroElement.style.setProperty("--computed-height", $6eb1cd88114a8aac$var$joinPageHeroContentElement.offsetHeight + ($6eb1cd88114a8aac$var$joinPageHeroPromotionElement !== null ? $6eb1cd88114a8aac$var$joinPageHeroPromotionElement.offsetHeight : 0) + "px");
                return [
                    2
                ];
            });
        }));
    });
    $6eb1cd88114a8aac$var$observer.observe($6eb1cd88114a8aac$var$joinPageHeroElement);
}


//
var $77beb629012c027d$var$letter = document.querySelector('.letter-to-mp div[data-name="letter"]');
//
if ($77beb629012c027d$var$letter != null && typeof $77beb629012c027d$var$letter != "undefined") {
    //
    var $77beb629012c027d$var$conElection = $77beb629012c027d$var$letter.getAttribute("data-election");
    var $77beb629012c027d$var$subject = $77beb629012c027d$var$letter.getAttribute("data-subjuct");
    //
    var $77beb629012c027d$var$sendButton = document.querySelector('.letter-to-mp button[data-name="send-button"]');
    if ($77beb629012c027d$var$sendButton != null) $77beb629012c027d$var$sendButton.disabled = $77beb629012c027d$var$conElection == 1 ? true : false;
    //set selected row then change name on letter
    if ($77beb629012c027d$var$conElection == 1) document.querySelector('.letter-to-mp tbody[data-name="candidate-table"]').addEventListener("click", function(event) {
        //
        var currentRow = event.target.closest('.letter-to-mp tr[data-name="candidate"]');
        Array.from(currentRow.parentNode.children).forEach(function(row) {
            row.classList.remove("selected");
        });
        currentRow.classList.add("selected");
        $77beb629012c027d$var$sendButton.disabled = false;
        //
        document.querySelector('.letter-to-mp i[data-name="candidate-name"]').innerHTML = "".concat(currentRow.dataset.canname, ",");
    });
    //open email in client
    $77beb629012c027d$var$sendButton === null || $77beb629012c027d$var$sendButton === void 0 ? void 0 : $77beb629012c027d$var$sendButton.addEventListener("click", function(event) {
        //
        if ($77beb629012c027d$var$sendButton.disabled == true) return;
        //
        var body = encodeURIComponent($77beb629012c027d$var$letter.innerText);
        //
        var to = $77beb629012c027d$var$conElection == 0 ? document.querySelector('.letter-to-mp tr[data-name="mp"]').dataset.email : null;
        //
        if ($77beb629012c027d$var$conElection == 1 && (selectedCandidate = document.querySelector('.letter-to-mp tr[data-name="candidate"].selected')) != null) to = selectedCandidate.dataset.email;
        //
        if (to != null) window.location.href = "mailto:".concat(to, "?subject=").concat($77beb629012c027d$var$subject, "&body=").concat(body);
    });
}


//
var $b3b53debdc52e1e1$var$_document_querySelectorAll;
($b3b53debdc52e1e1$var$_document_querySelectorAll = document.querySelectorAll(".news-slider sl-carousel")) === null || $b3b53debdc52e1e1$var$_document_querySelectorAll === void 0 ? void 0 : $b3b53debdc52e1e1$var$_document_querySelectorAll.forEach(function(slider) {
    //
    var isDragging = false;
    //detect the start of a drag
    slider.addEventListener("mousedown", function() {
        isDragging = false;
    });
    //
    slider.addEventListener("mousemove", function() {
        isDragging = true;
    });
    //detect the end of a drag
    slider.addEventListener("mouseup", function() {
        setTimeout(function() {
            isDragging = false;
        }, 100);
    });
    //prevent anchor default action during a drag
    slider.querySelectorAll("a").forEach(function(anchor) {
        anchor.addEventListener("click", function(event) {
            if (isDragging) event.preventDefault();
        });
    });
    //
    var resizeObserver = new ResizeObserver(function(entries) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (entry.contentRect.width < 600) slider.setAttribute("slides-per-page", "1");
                else if (entry.contentRect.width < 850) slider.setAttribute("slides-per-page", "2");
                else slider.setAttribute("slides-per-page", "3");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    resizeObserver.observe(slider);
});


//

var $7K4bb = parcelRequire("7K4bb");

var $eqJqJ = parcelRequire("eqJqJ");
function $81d02f891db7c06c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $81d02f891db7c06c$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $81d02f891db7c06c$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");
var $a30cc47b4b4c82d1$var$newsletterButtons = document.querySelectorAll(".newsletter-button");

var $70P4J = parcelRequire("70P4J");

var $fZi8Q = parcelRequire("fZi8Q");

var $k2ek2 = parcelRequire("k2ek2");

var $dRAC6 = parcelRequire("dRAC6");
var $a30cc47b4b4c82d1$var$_iteratorNormalCompletion = true, $a30cc47b4b4c82d1$var$_didIteratorError = false, $a30cc47b4b4c82d1$var$_iteratorError = undefined;
//
if ($a30cc47b4b4c82d1$var$newsletterButtons != null) try {
    var $a30cc47b4b4c82d1$var$_loop = function() {
        var newsletterButton = $a30cc47b4b4c82d1$var$_step.value;
        //
        var newsletterButtonContent = newsletterButton.querySelector(".newsletter-button-content");
        var newsletterButtonCallToAction = newsletterButton.querySelector(".newsletter-button-cta");
        var newsletterButtonForm = newsletterButton.querySelector(".newsletter-button-form");
        var step2form = newsletterButton.querySelector(".step-2-form");
        var step1 = newsletterButton.querySelector(".step-1");
        var step2 = newsletterButton.querySelector(".step-2");
        //
        var buttonLoggedIn = newsletterButton.querySelector(".newsletter-button-user-loggedin");
        //
        var validateEmail = function(email) {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        };
        //
        var displayUpdateNewsletterPreferencesResponse = function(status, messages) {
            var //
            _newsletterButtonForm_querySelector;
            (_newsletterButtonForm_querySelector = newsletterButtonForm.querySelector('button:not([type="button"])')) === null || _newsletterButtonForm_querySelector === void 0 ? void 0 : _newsletterButtonForm_querySelector.removeAttribute("disabled");
            //
            newsletterButton.querySelectorAll(".form-status-message").forEach(function(statusMessageBlock) {
                statusMessageBlock.remove();
            });
            if (buttonLoggedIn != undefined) {
                //check to see if the form (still) exists, if it does add the status message to it, else default to the component root
                var statusMessageTarget = buttonLoggedIn;
                var statusMessageBlock = $70P4J("div", {
                    "class": "form-status-message",
                    "data-status": status
                });
                statusMessageTarget.append(statusMessageBlock);
            }
            //check to see if the form (still) exists, if it does add the status message to it, else default to the component root
            var statusMessageTarget1 = newsletterButton.querySelector(".newsletter-button-form") !== null ? newsletterButtonForm : newsletterButton;
            //
            var statusMessageBlock1 = $70P4J("div", {
                "class": "form-status-message",
                "data-status": status
            });
            statusMessageTarget1.append(statusMessageBlock1);
            //
            if (status === "error") messages.forEach(function(message) {
                statusMessageBlock1.append($70P4J("div", {}, message));
            });
            else statusMessageBlock1.innerHTML = newsletterButton.dataset.successMessage;
        };
        //
        var updateNewsletterPreferences = function() {
            var _ref = (0, $7K4bb._)(function(payload) {
                var _ref, status, messages;
                return (0, $cX5iq.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $fZi8Q("post", "/api/update-newsletter-preferences", {}, (0, $81d02f891db7c06c$export$4fa2f4023c9cbda5)((0, $eqJqJ._)({}, payload || {}), {
                                    "subscriptions": newsletterButton.dataset.subscriptions
                                }))
                            ];
                        case 1:
                            _ref = (0, $haqKc._).apply(void 0, [
                                _state.sent(),
                                2
                            ]), status = _ref[0], messages = _ref[1];
                            //
                            if (status == "success") {
                                if (step2form) step2form.innerHTML = "";
                                else if (buttonLoggedIn) buttonLoggedIn.innerHTML = "";
                                else newsletterButton.innerHTML = "";
                            }
                            //
                            if (newsletterButtonForm !== null && status == "error") window.grecaptcha.reset(grecaptchaWidget);
                            //
                            displayUpdateNewsletterPreferencesResponse(status, messages);
                            return [
                                2
                            ];
                    }
                });
            });
            return function updateNewsletterPreferences(payload) {
                return _ref.apply(this, arguments);
            };
        }();
        //if the form is missing, we can assume a member is authenticated, so send the submission and let the server deal with it
        if (newsletterButtonForm === null) {
            //
            newsletterButtonCallToAction.addEventListener("click", $k2ek2(200, function(event) {
                updateNewsletterPreferences({});
            }));
            //
            return "continue";
        }
        //toggle the display of the button and form
        newsletterButtonCallToAction.addEventListener("click", $k2ek2(200, function(event) {
            //
            var emailValue = newsletterButtonForm.querySelector('input[name="email"]').value.trim();
            //validate email before proceeding
            if (!validateEmail(emailValue)) {
                //
                var fieldErrorMessage = $70P4J("div", {
                    "class": "input-error-message",
                    "data-status": "error"
                });
                fieldErrorMessage.innerHTML = "Please enter a valid email address";
                //
                var inputGroup = newsletterButtonForm.querySelector(".step-1 .input-group");
                if (inputGroup) {
                    //clear any existing error messages
                    var existingErrorMessage = inputGroup.querySelector(".input-error-message");
                    if (existingErrorMessage) existingErrorMessage.remove();
                    //append the error message to the input group
                    inputGroup.append(fieldErrorMessage);
                    return;
                }
            }
            //set the text of the span with data-name="emailAddress"
            var emailAddressSpan = newsletterButton.querySelector('span[data-name="emailAddress"]');
            if (emailAddressSpan) emailAddressSpan.textContent = emailValue;
            //
            newsletterButtonCallToAction.style.display = "none";
            newsletterButtonForm.style.display = "flex";
            step1.style.display = "none";
            step2.style.display = "block";
        }));
        //disable the submit button, this can be reenabled once the recaptcha has been completed
        newsletterButtonForm.querySelector('button:not([type="button"])').setAttribute("disabled", "disabled");
        var grecaptchaWidget = $dRAC6(newsletterButtonForm.querySelector('input[name="grecaptcha"]'), function() {
            newsletterButtonForm.querySelector('button:not([type="button"])').removeAttribute("disabled");
        });
        //
        newsletterButtonForm.addEventListener("submit", function(event) {
            event.preventDefault();
            event.stopPropagation();
        });
        //
        newsletterButtonForm.addEventListener("submit", $k2ek2(200, function(event) {
            //
            var newsletterButtonFormData = new FormData(newsletterButtonForm);
            //get the values of firstname and surname
            var firstname = newsletterButtonFormData.get("firstname").trim();
            var surname = newsletterButtonFormData.get("surname").trim();
            //check if firstname or surname is empty
            if (!firstname || !surname) {
                //create the error message element
                var fieldErrorMessage = $70P4J("div", {
                    "class": "input-error-message",
                    "data-status": "error"
                });
                fieldErrorMessage.innerHTML = "Please enter both first name and last name.";
                //
                var fieldsContainer = newsletterButtonForm.querySelector(".fieldsContainer");
                //check if .fieldsContainer exists and insert the error message after it
                if (fieldsContainer) {
                    fieldsContainer.insertAdjacentElement("afterend", fieldErrorMessage);
                    return; //stop the form submission if validation fails
                }
            }
            //disable the button while we wait for the response
            newsletterButtonForm.querySelector('button:not([type="button"])').setAttribute("disabled", "disabled");
            //
            updateNewsletterPreferences({
                "formSent": newsletterButtonFormData.get("formSent"),
                "formToken": newsletterButtonFormData.get("formToken"),
                "formCaptcha": newsletterButtonFormData.get("grecaptcha"),
                "firstname": newsletterButtonFormData.get("firstname"),
                "surname": newsletterButtonFormData.get("surname"),
                "email": newsletterButtonFormData.get("email")
            });
        }));
    };
    //lets disable the buttons on the forms until the captcha is collected
    for(var $a30cc47b4b4c82d1$var$_iterator = $a30cc47b4b4c82d1$var$newsletterButtons[Symbol.iterator](), $a30cc47b4b4c82d1$var$_step; !($a30cc47b4b4c82d1$var$_iteratorNormalCompletion = ($a30cc47b4b4c82d1$var$_step = $a30cc47b4b4c82d1$var$_iterator.next()).done); $a30cc47b4b4c82d1$var$_iteratorNormalCompletion = true)$a30cc47b4b4c82d1$var$_loop();
} catch (err) {
    $a30cc47b4b4c82d1$var$_didIteratorError = true;
    $a30cc47b4b4c82d1$var$_iteratorError = err;
} finally{
    try {
        if (!$a30cc47b4b4c82d1$var$_iteratorNormalCompletion && $a30cc47b4b4c82d1$var$_iterator.return != null) {
            $a30cc47b4b4c82d1$var$_iterator.return();
        }
    } finally{
        if ($a30cc47b4b4c82d1$var$_didIteratorError) {
            throw $a30cc47b4b4c82d1$var$_iteratorError;
        }
    }
}


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");



document.querySelectorAll('form[name="new-online-advice-enquiry"]').forEach(function(enquiryForm) {
    //
    var debounce = (parcelRequire("k2ek2"));
    var zenoFetch = (parcelRequire("fZi8Q"));
    var createElement = (parcelRequire("70P4J"));
    //this will be called by the validation system (if the form validates)
    enquiryForm.nrlaSubmitCallback = /*#__PURE__*/ (0, $7K4bb._)(function() {
        var //
        _enquiryForm_querySelector, enquiryFormData, _ref, status, message;
        return (0, $cX5iq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (_enquiryForm_querySelector = enquiryForm.querySelector(".form-status-message")) === null || _enquiryForm_querySelector === void 0 ? void 0 : _enquiryForm_querySelector.remove();
                    //
                    enquiryFormData = new FormData(enquiryForm);
                    return [
                        4,
                        zenoFetch("post", "/api/new-online-advice-enquiry", null, enquiryFormData)
                    ];
                case 1:
                    _ref = (0, $haqKc._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), status = _ref[0], message = _ref[1];
                    //
                    enquiryForm.insertAdjacentElement("afterbegin", createElement("p", {
                        "class": "form-status-message",
                        "data-status": status
                    }, message));
                    //
                    if (status == "success") enquiryForm.reset();
                    return [
                        2
                    ];
            }
        });
    });
});


var $fd8f99cabb59cbbc$var$passwordContainers = document.querySelectorAll("[data-password-toggle]");
$fd8f99cabb59cbbc$var$passwordContainers.forEach(function(passwordContainer) {
    //
    var passwordField = passwordContainer.querySelector('[type="password"]');
    var icon = passwordContainer.querySelector("[data-password-toggle-icon]");
    if (passwordField != null && icon != null) passwordContainer.addEventListener("click", function(event) {
        if (event.target.matches("[data-password-toggle-icon]")) {
            if (passwordField.type === "password") {
                passwordField.type = "text";
                icon.classList.remove("fa-eye");
                icon.classList.add("fa-eye-slash");
            } else {
                passwordField.type = "password";
                icon.classList.remove("fa-eye-slash");
                icon.classList.add("fa-eye");
            }
        }
    });
});


//
if (document.querySelector(".recognised-suppliers") != null) {
    //
    var $f78213bce29c0b79$var$themeEmphasisMap = {
        "off-white": "blue",
        "blue": "orange",
        "featured-branded": "blue",
        "orange": "orange",
        "well": "blue"
    };
    //
    var $f78213bce29c0b79$var$recognisedSuppliersContainers = document.querySelectorAll("section.container:has(div.recognised-suppliers)");
    //
    $f78213bce29c0b79$var$recognisedSuppliersContainers.forEach(function(container) {
        //get the theme from the container
        var theme = container.dataset.theme || "off-white";
        //handle wells
        theme = theme.startsWith("well") ? "well" : theme;
        //change the theme of the button based on the emphasis colour of the theme
        var emphasisTheme = $f78213bce29c0b79$var$themeEmphasisMap[theme];
        container.querySelectorAll(".recognised-suppliers button").forEach(function(button) {
            button.setAttribute("data-theme", emphasisTheme);
        });
    });
}
//
document.querySelectorAll(".recognised-suppliers").forEach(function(recognisedSuppliersComponent) {
    var updateRecognisedSuppliers = //
    function updateRecognisedSuppliers() {
        var selectedOption = recognisedSuppliersFilter.querySelector('select[name="category"]').querySelector("option:checked");
        recognisedSuppliersItems.querySelectorAll(".supplier").forEach(function(supplier) {
            supplier.classList.toggle("hidden", !(selectedOption === null || selectedOption.value === "" || supplier.dataset.category === selectedOption.value));
        });
    };
    //
    var recognisedSuppliersFilter = recognisedSuppliersComponent.querySelector(".recognised-suppliers-filter");
    var recognisedSuppliersItems = recognisedSuppliersComponent.querySelector(".recognised-suppliers-items");
    //update the displayed items when the "category" filter is applied
    recognisedSuppliersFilter.querySelector('select[name="category"]').addEventListener("change", function(event) {
        updateRecognisedSuppliers();
    });
    //
    updateRecognisedSuppliers();
    //before running our own logic, see if the browser supports the masonary spec, if not - then get to work!
    if (!CSS.supports("grid-template-rows", "masonry")) {
        //
        recognisedSuppliersItems.setAttribute("data-masonry", "active");
        //wrap the children of each "supplier" in a container - will use this to calculate the deired supplier height later
        Array.from(recognisedSuppliersItems.children).forEach(function(supplier) {
            var container = document.createElement("div");
            Array.from(supplier.children).forEach(function(element) {
                container.appendChild(element);
            });
            supplier.appendChild(container);
        });
        //resize a single supplier in the recognisedSuppliersItems
        var resizeSupplier = function(supplier) {
            //get the height of each row, and the gap
            rowHeight = parseInt(window.getComputedStyle(recognisedSuppliersItems).getPropertyValue("grid-auto-rows"));
            rowGap = parseInt(window.getComputedStyle(recognisedSuppliersItems).getPropertyValue("grid-row-gap"));
            //calculate how many grid rows the supplier spans, based on the height of the immediate child (we should only have one!)
            supplier.style.gridRowEnd = "span ".concat(Math.ceil((supplier.children[0].getBoundingClientRect().height + rowGap) / (rowHeight + rowGap)));
        };
        //use a resize observer to pick on anytime the suppler element change size (images loads/viewport changes etc)
        var resizeObserver = new ResizeObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    resizeSupplier(entry.target.closest(".supplier"));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        //resize all the suppliers in the recognisedSuppliersItems
        var resizeAllsuppliers = function() {
            Array.from(recognisedSuppliersItems.children).forEach(function(supplier) {
                resizeSupplier(supplier);
                resizeObserver.observe(supplier.children[0]);
            });
        };
        //run the initial resize on the next render frame
        setTimeout(function() {
            return resizeAllsuppliers();
        }, 0);
    }
});


//
////
//if (typeof autoComplete === 'undefined') {
//    return;
//}
//
////
//const sessionStorage = require('../utils/sessionStorage.js');
//const zenoFetch      = require('../utils/zenoFetch.js');
//const createElement  = require('../utils/createElement.js');
//
////
//document.querySelectorAll('input[name="search"][data-autocomplete]').forEach((input, index) => {
//
//    //
//    input.setAttribute('id', `search-input-${index}`)
//
//    //
//    const autoCompleteJS = new autoComplete({
//
//        //
//        'selector': `input[name="search"][data-autocomplete]#search-input-${index}`,
//
//        //
//        'submit': true,
//
//        //
//        'data': {
//            'src': async function () {
//
//                //
//                const cachedOptions = sessionStorage.get('nrla-search-autocomplete');
//                if (cachedOptions !== null) {
//                    return cachedOptions;
//                }
//
//                //
//                const [status, options] = await zenoFetch('get', '/api/search-autocomplete');
//
//                //
//                if (status == 'success') {
//                    sessionStorage.set('nrla-search-autocomplete', options);
//                    return options;
//                }
//
//                //
//                return [];
//
//            },
//            'cache': true,
//        },
//
//        //
//        'resultsList': {
//            'element': (list, data) => {
//                const searchSuggestion = createElement('div', { 'class' : 'search-suggestion' });
//                searchSuggestion.append(createElement('span', {}, `Search for “${data.query}”`));
//                list.prepend(searchSuggestion);
//            },
//        },
//
//        //
//        'resultItem': {
//            'highlight': true
//        },
//
//        //
//        'events': {
//            'input': {
//                'selection': (event) => {
//                    autoCompleteJS.input.value = event.detail.selection.value;
//                    autoCompleteJS.input.closest('form').submit();
//                }
//            }
//        }
//
//    });
//});


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");
var $c23b44ce6c922550$var$serviceButton = document.querySelector('.service-button[data-service="bunk-portfolio"]');


//
if ($c23b44ce6c922550$var$serviceButton !== null) {
    //
    var $c23b44ce6c922550$var$zenoFetch = (parcelRequire("fZi8Q"));
    var $c23b44ce6c922550$var$createElement = (parcelRequire("70P4J"));
    //toggle the information panel as needed
    $c23b44ce6c922550$var$serviceButton.addEventListener("click", function(event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) event.target.closest(".service-button").setAttribute("data-show-service-information", $c23b44ce6c922550$var$serviceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
    });
    //if this is the first time using the service, you must agree that you are using the service for your own properties
    if ($c23b44ce6c922550$var$serviceButton.querySelector('input[name="agreeBunkPortfolioTermsAndConditions"]') !== null) $c23b44ce6c922550$var$serviceButton.querySelector('input[name="agreeBunkPortfolioTermsAndConditions"]').addEventListener("change", function(event) {
        $c23b44ce6c922550$var$serviceButton.querySelector('button[data-action="open-bunk-portfolio"]').disabled = !event.target.checked;
    });
    //
    var $c23b44ce6c922550$var$setLoadingState = function setLoadingState(state) {
        if ((button = $c23b44ce6c922550$var$serviceButton.querySelector('button[data-action="open-bunk-portfolio"]')) !== null) {
            button.toggleAttribute("data-loading", state);
            button.disabled = state;
        }
    };
    //
    var $c23b44ce6c922550$var$setErrorMessage = function setErrorMessage(message) {
        //
        $c23b44ce6c922550$var$serviceButton.classList.toggle("service-button-error", message !== null);
        //
        if (message === null && (serviceButtonButtonErrorMessage = $c23b44ce6c922550$var$serviceButton.querySelector('.service-button-button p[data-name="error-message"]'))) serviceButtonButtonErrorMessage.remove();
        //
        if (message !== null) {
            var serviceButtonButtonContainer = $c23b44ce6c922550$var$serviceButton.querySelector(".service-button-button");
            serviceButtonButtonContainer.insertAdjacentElement("beforeend", $c23b44ce6c922550$var$createElement("p", {
                "data-name": "error-message"
            }, message));
        }
    };
    //
    $c23b44ce6c922550$var$serviceButton.addEventListener("click", function() {
        var _ref = (0, $7K4bb._)(function(event) {
            var _ref, status, message;
            return (0, $cX5iq.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //use event delegation to only deal with the "continue" button when it's not been disabled
                        if (!event.target.matches('button[data-action="open-bunk-portfolio"]:not(:disabled)')) return [
                            2
                        ];
                        //
                        event.preventDefault();
                        //
                        $c23b44ce6c922550$var$setLoadingState(true);
                        $c23b44ce6c922550$var$setErrorMessage(null);
                        return [
                            4,
                            $c23b44ce6c922550$var$zenoFetch("post", "/api/get-bunk-portfolio-auth-token")
                        ];
                    case 1:
                        _ref = (0, $haqKc._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), status = _ref[0], message = _ref[1];
                        //
                        if (status == "success") {
                            window.location = "/portfolio/";
                            return [
                                2
                            ];
                        }
                        //
                        $c23b44ce6c922550$var$setLoadingState(false);
                        $c23b44ce6c922550$var$setErrorMessage(message);
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }());
}


//
var $2e1384f90aa3b9c4$var$custodialServiceButtons = document.querySelectorAll('.service-button[data-service="depositguard-custodial-personal"], .service-button[data-service="depositguard-custodial-company"]');

if ($2e1384f90aa3b9c4$var$custodialServiceButtons !== undefined && $2e1384f90aa3b9c4$var$custodialServiceButtons.length > 0) {
    //
    var $2e1384f90aa3b9c4$var$createElement = (parcelRequire("70P4J"));
    var $2e1384f90aa3b9c4$var$_iteratorNormalCompletion = true, $2e1384f90aa3b9c4$var$_didIteratorError = false, $2e1384f90aa3b9c4$var$_iteratorError = undefined;
    try {
        var $2e1384f90aa3b9c4$var$_loop = function() {
            var custodialServiceButton = $2e1384f90aa3b9c4$var$_step.value;
            var //
            _custodialServiceButton_querySelector;
            //
            var serviceName = custodialServiceButton.dataset.service;
            //
            var requestServiceToken = function requestServiceToken(callback) {
                var promise = fetch(serviceName == "depositguard-custodial-personal" ? "/api/get-depositguard-custodial-personal-service-token" : "/api/get-depositguard-custodial-company-service-token", {
                    "method": "POST"
                });
                promise.then(function(response) {
                    return response.json();
                }).then(function(response) {
                    callback(response);
                }).catch(function(error) {
                    //no token - now what?
                    console.error(error);
                });
            };
            //if this is the first time using the service, you must agree that you are using the service for your own properties
            if (custodialServiceButton.querySelector('input[name="understand-only-own-manage"]') !== null) custodialServiceButton.querySelector('input[name="understand-only-own-manage"]').addEventListener("change", function(event) {
                custodialServiceButton.querySelector('button[data-action="get-depositguard-custodial-service-token"]').disabled = !event.target.checked;
            });
            //toggle the information panel as needed
            custodialServiceButton.addEventListener("click", function(event) {
                if (event.target.matches('[data-action="toggle-service-information"]') == true) event.target.closest(".service-button").setAttribute("data-show-service-information", custodialServiceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
            });
            (_custodialServiceButton_querySelector = custodialServiceButton.querySelector('button[data-action="get-depositguard-custodial-service-token"]')) === null || _custodialServiceButton_querySelector === void 0 ? void 0 : _custodialServiceButton_querySelector.addEventListener("click", function(event) {
                //
                if (event.target.disabled == true) return false;
                //
                event.preventDefault();
                event.stopPropagation();
                //
                event.target.disabled = true;
                //
                requestServiceToken(function(response) {
                    var serviceButtonForm = custodialServiceButton.querySelector(".service-button-button");
                    //
                    serviceButtonForm.append($2e1384f90aa3b9c4$var$createElement("input", {
                        "type": "hidden",
                        "name": "nrla_guid",
                        "value": response.details.serviceToken
                    }));
                    serviceButtonForm.append($2e1384f90aa3b9c4$var$createElement("input", {
                        "type": "hidden",
                        "name": "auth_token",
                        "value": response.details.token
                    }));
                    serviceButtonForm.append($2e1384f90aa3b9c4$var$createElement("input", {
                        "type": "hidden",
                        "name": "expiry_time",
                        "value": response.details.expiry
                    }));
                    //
                    serviceButtonForm.submit();
                });
            });
        };
        //
        for(var $2e1384f90aa3b9c4$var$_iterator = $2e1384f90aa3b9c4$var$custodialServiceButtons[Symbol.iterator](), $2e1384f90aa3b9c4$var$_step; !($2e1384f90aa3b9c4$var$_iteratorNormalCompletion = ($2e1384f90aa3b9c4$var$_step = $2e1384f90aa3b9c4$var$_iterator.next()).done); $2e1384f90aa3b9c4$var$_iteratorNormalCompletion = true)$2e1384f90aa3b9c4$var$_loop();
    } catch (err) {
        $2e1384f90aa3b9c4$var$_didIteratorError = true;
        $2e1384f90aa3b9c4$var$_iteratorError = err;
    } finally{
        try {
            if (!$2e1384f90aa3b9c4$var$_iteratorNormalCompletion && $2e1384f90aa3b9c4$var$_iterator.return != null) {
                $2e1384f90aa3b9c4$var$_iterator.return();
            }
        } finally{
            if ($2e1384f90aa3b9c4$var$_didIteratorError) {
                throw $2e1384f90aa3b9c4$var$_iteratorError;
            }
        }
    }
}


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");
var $26005c4078c3e220$var$insuredServiceButtons = document.querySelectorAll('.service-button[data-service="tds-insured-personal"], .service-button[data-service="tds-insured-company"]');

//
if ($26005c4078c3e220$var$insuredServiceButtons !== undefined && $26005c4078c3e220$var$insuredServiceButtons.length > 0) {
    //
    var $26005c4078c3e220$var$zenoFetch = (parcelRequire("fZi8Q"));
    var $26005c4078c3e220$var$_iteratorNormalCompletion = true, $26005c4078c3e220$var$_didIteratorError = false, $26005c4078c3e220$var$_iteratorError = undefined;
    try {
        var $26005c4078c3e220$var$_loop = function() {
            var insuredServiceButton = $26005c4078c3e220$var$_step.value;
            var //
            _insuredServiceButton_querySelector;
            //if this is the first time using the service, you must agree that you are using the service for your own properties
            if (insuredServiceButton.querySelector('input[name="agree-manage-only-own-properties"]') !== null) insuredServiceButton.querySelector('input[name="agree-manage-only-own-properties"]').addEventListener("change", function(event) {
                insuredServiceButton.querySelector('button[data-action="manage-deposits"]').disabled = !event.target.checked;
            });
            //toggle the information panel as needed
            insuredServiceButton.querySelectorAll('[data-action="toggle-service-information"]').forEach(function(toggleButton) {
                toggleButton.addEventListener("click", function(event) {
                    insuredServiceButton.setAttribute("data-show-service-information", insuredServiceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
                });
            });
            (_insuredServiceButton_querySelector = insuredServiceButton.querySelector('button[data-action="manage-deposits"]')) === null || _insuredServiceButton_querySelector === void 0 ? void 0 : _insuredServiceButton_querySelector.addEventListener("click", function() {
                var _ref = (0, $7K4bb._)(function(event) {
                    var _ref, status, response, serviceButtonForm;
                    return (0, $cX5iq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                //
                                if (event.target.disabled == true) return [
                                    2,
                                    false
                                ];
                                //
                                event.preventDefault();
                                event.stopPropagation();
                                //
                                event.target.disabled = true;
                                return [
                                    4,
                                    $26005c4078c3e220$var$zenoFetch("post", "/api/submit-tenancy-deposit-scheme-insured", null, {
                                        "type": insuredServiceButton.dataset.service == "tds-insured-personal" ? "personal" : "company"
                                    })
                                ];
                            case 1:
                                _ref = (0, $haqKc._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), status = _ref[0], response = _ref[1];
                                //
                                if (status == "success") {
                                    serviceButtonForm = insuredServiceButton.querySelector(".service-button-button");
                                    serviceButtonForm.submit();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }());
        };
        //
        for(var $26005c4078c3e220$var$_iterator = $26005c4078c3e220$var$insuredServiceButtons[Symbol.iterator](), $26005c4078c3e220$var$_step; !($26005c4078c3e220$var$_iteratorNormalCompletion = ($26005c4078c3e220$var$_step = $26005c4078c3e220$var$_iterator.next()).done); $26005c4078c3e220$var$_iteratorNormalCompletion = true)$26005c4078c3e220$var$_loop();
    } catch (err) {
        $26005c4078c3e220$var$_didIteratorError = true;
        $26005c4078c3e220$var$_iteratorError = err;
    } finally{
        try {
            if (!$26005c4078c3e220$var$_iteratorNormalCompletion && $26005c4078c3e220$var$_iterator.return != null) {
                $26005c4078c3e220$var$_iterator.return();
            }
        } finally{
            if ($26005c4078c3e220$var$_didIteratorError) {
                throw $26005c4078c3e220$var$_iteratorError;
            }
        }
    }
}


//
var $34cd3baff50adb41$var$serviceButton = document.querySelector('.service-button[data-service="homebox"]');


//
if ($34cd3baff50adb41$var$serviceButton !== null) {
    //
    var $34cd3baff50adb41$var$getResponse = (parcelRequire("lNLDS"));
    var $34cd3baff50adb41$var$createElement = (parcelRequire("70P4J"));
    //toggle the information panel as needed
    $34cd3baff50adb41$var$serviceButton.addEventListener("click", function(event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) event.target.closest(".service-button").setAttribute("data-show-service-information", $34cd3baff50adb41$var$serviceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
    });
    //
    $34cd3baff50adb41$var$serviceButton.querySelector('button[data-action="get-homebox-token"]').addEventListener("click", function(event) {
        //
        if (event.target.disabled == true) return false;
        //
        event.preventDefault();
        event.stopPropagation();
        //
        event.target.disabled = true;
        //
        $34cd3baff50adb41$var$getResponse("/api/get-homebox-service-token").then(function(response) {
            //
            var form = $34cd3baff50adb41$var$serviceButton.querySelector(".service-button-button");
            //
            form.appendChild($34cd3baff50adb41$var$createElement("input", {
                "type": "hidden",
                "name": "serviceToken",
                "value": response.details.serviceToken
            }));
            form.appendChild($34cd3baff50adb41$var$createElement("input", {
                "type": "hidden",
                "name": "serviceTokenHash",
                "value": response.details.serviceTokenHash
            }));
            //
            form.submit();
        });
    });
}


//
var $efeb3e31a708d150$var$serviceButton = document.querySelector('.service-button[data-service="mydeposits"]');


//
if ($efeb3e31a708d150$var$serviceButton !== null) {
    //
    var $efeb3e31a708d150$var$getResponse = (parcelRequire("lNLDS"));
    var $efeb3e31a708d150$var$createElement = (parcelRequire("70P4J"));
    //toggle the information panel as needed
    $efeb3e31a708d150$var$serviceButton.addEventListener("click", function(event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) event.target.closest(".service-button").setAttribute("data-show-service-information", $efeb3e31a708d150$var$serviceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
    });
    //
    $efeb3e31a708d150$var$serviceButton.querySelector('button[data-action="get-mydeposits-token"]').addEventListener("click", function(event) {
        //
        if (event.target.disabled == true) return false;
        //
        event.preventDefault();
        event.stopPropagation();
        //
        event.target.disabled = true;
        //
        $efeb3e31a708d150$var$getResponse("/api/get-mydeposits-service-token").then(function(response) {
            //
            var form = $efeb3e31a708d150$var$serviceButton.querySelector(".service-button-button");
            //
            form.appendChild($efeb3e31a708d150$var$createElement("input", {
                "type": "hidden",
                "name": "serviceToken",
                "value": response.details.serviceToken
            }));
            form.appendChild($efeb3e31a708d150$var$createElement("input", {
                "type": "hidden",
                "name": "serviceTokenHash",
                "value": response.details.serviceTokenHash
            }));
            //
            form.submit();
        });
    });
}


//
var $16d773a7df36bc15$var$tenantReferencingServiceButton = document.querySelector('.service-button[data-service="tenant-referencing"]');
if ($16d773a7df36bc15$var$tenantReferencingServiceButton !== null) {
    var $16d773a7df36bc15$var$requestServiceToken = //
    function requestServiceToken(callback) {
        var promise = fetch("/api/get-tenant-referencing-service-token", {
            "method": "POST"
        });
        promise.then(function(response) {
            return response.json();
        }).then(function(response) {
            callback(response);
        }).catch(function(error) {
            console.error(error);
        });
    };
    var $16d773a7df36bc15$var$createFormElement = //
    function createFormElement(type, name, value) {
        var input = document.createElement("input");
        input.type = type;
        input.name = name;
        input.value = value;
        return input;
    };
    //toggle the information panel as needed
    $16d773a7df36bc15$var$tenantReferencingServiceButton.addEventListener("click", function(event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) event.target.closest(".service-button").setAttribute("data-show-service-information", $16d773a7df36bc15$var$tenantReferencingServiceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
    });
    //
    $16d773a7df36bc15$var$tenantReferencingServiceButton.querySelector('button[data-action="get-tenant-referencing-service-token"]').addEventListener("click", function(event) {
        //
        if (event.target.disabled == true) return false;
        //
        event.preventDefault();
        event.stopPropagation();
        //
        event.target.disabled = true;
        //
        $16d773a7df36bc15$var$requestServiceToken(function(response) {
            var serviceTokenInput = $16d773a7df36bc15$var$createFormElement("hidden", "serviceToken", response.details.serviceToken);
            var serviceTokenHashInput = $16d773a7df36bc15$var$createFormElement("hidden", "serviceTokenHash", response.details.serviceTokenHash);
            var form = $16d773a7df36bc15$var$tenantReferencingServiceButton.querySelector(".service-button-button");
            form.appendChild(serviceTokenInput);
            form.appendChild(serviceTokenHashInput);
            form.submit();
        });
    });
}


//
var $355212c450bb7e9c$var$titleGuardianServiceButton = document.querySelector('.service-button[data-service="title-guardian"]');


//
if ($355212c450bb7e9c$var$titleGuardianServiceButton !== null) {
    //
    var $355212c450bb7e9c$var$getResponse = (parcelRequire("lNLDS"));
    var $355212c450bb7e9c$var$createElement = (parcelRequire("70P4J"));
    //toggle the information panel as needed
    $355212c450bb7e9c$var$titleGuardianServiceButton.addEventListener("click", function(event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) event.target.closest(".service-button").setAttribute("data-show-service-information", $355212c450bb7e9c$var$titleGuardianServiceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
    });
    //
    $355212c450bb7e9c$var$titleGuardianServiceButton.querySelector('button[data-action="get-title-guardian-token"]').addEventListener("click", function(event) {
        //
        if (event.target.disabled == true) return false;
        //
        event.preventDefault();
        event.stopPropagation();
        //
        event.target.disabled = true;
        //
        $355212c450bb7e9c$var$getResponse("/api/get-title-guardian-service-token").then(function(response) {
            //
            $355212c450bb7e9c$var$titleGuardianServiceButton.querySelector(".service-button-button").classList.add("hidden");
            //
            if (response.details.responseStatus === 200) {
                //mobile view
                mobileView = $355212c450bb7e9c$var$createElement("div", {
                    "class": "title-guardian-mobile-sign-up"
                });
                //
                mobileView.append($355212c450bb7e9c$var$createElement("a", {
                    "class": "btn btn-primary mobile-sign-up-url",
                    "href": response.details.mobileSignUpUrl
                }, "Download the app to sign up"));
                link = $355212c450bb7e9c$var$createElement("p");
                link.append($355212c450bb7e9c$var$createElement("a", {
                    "class": "sign-up-url",
                    "href": response.details.signUpUrl
                }, "Not on a mobile device?"));
                mobileView.append(link);
                //desktop view
                desktopView = $355212c450bb7e9c$var$createElement("div", {
                    "class": "title-guardian-desktop-sign-up"
                });
                //
                desktopView.append($355212c450bb7e9c$var$createElement("img", {
                    "class": "sign-up-qr",
                    "src": response.details.QRCode
                }));
                desktopView.append($355212c450bb7e9c$var$createElement("p"));
                desktopView.querySelector("p").append($355212c450bb7e9c$var$createElement("a", {
                    "class": "mobile-sign-up-url",
                    "href": response.details.mobileSignUpUrl
                }, "On a mobile device?"));
                desktopView.append($355212c450bb7e9c$var$createElement("a", {
                    "class": "btn btn-primary btn-large sign-up-url",
                    "href": response.details.signUpUrl
                }, "Sign up on desktop"));
                //
                $355212c450bb7e9c$var$titleGuardianServiceButton.append(mobileView);
                $355212c450bb7e9c$var$titleGuardianServiceButton.append(desktopView);
                //
                return;
            }
            //
            if (response.details.responseStatus === 409) {
                //
                alreadyRegisteredView = $355212c450bb7e9c$var$createElement("div", {
                    "class": "title-guardian-already-registered",
                    "data-signUpUrl": response.details.signInUrl,
                    "data-mobileSignUpUrl": response.details.mobileSignInUrl
                });
                //
                alreadyRegisteredView.append($355212c450bb7e9c$var$createElement("p", {}, "Looks like you already have an account with Title Guardian, "));
                alreadyRegisteredView.querySelector("p").append($355212c450bb7e9c$var$createElement("a", {
                    "class": "mobile-sign-up-url",
                    href: response.details.mobileSignInUrl
                }, "click here to log in."));
                alreadyRegisteredView.querySelector("p").append($355212c450bb7e9c$var$createElement("a", {
                    "class": "sign-up-url",
                    href: response.details.signInUrl
                }, "click here to log in."));
                //
                $355212c450bb7e9c$var$titleGuardianServiceButton.append(alreadyRegisteredView);
                //
                return;
            }
            //
            errorResponse = $355212c450bb7e9c$var$createElement("div", {
                "class": "title-guardian-error-response"
            });
            //
            errorResponse.append($355212c450bb7e9c$var$createElement("p", {}, response.message));
            //
            $355212c450bb7e9c$var$titleGuardianServiceButton.append(errorResponse);
            return;
        });
    });
}


//

var $7K4bb = parcelRequire("7K4bb");

var $haqKc = parcelRequire("haqKc");

var $cX5iq = parcelRequire("cX5iq");
var $95251e8ba9094fc2$var$serviceButtons = document.querySelectorAll('.service-button[data-service="total-landlord-insurance"]');


if ($95251e8ba9094fc2$var$serviceButtons !== undefined && $95251e8ba9094fc2$var$serviceButtons.length > 0) {
    //
    var $95251e8ba9094fc2$var$zenoFetch = (parcelRequire("fZi8Q"));
    var $95251e8ba9094fc2$var$createElement = (parcelRequire("70P4J"));
    var $95251e8ba9094fc2$var$_iteratorNormalCompletion = true, $95251e8ba9094fc2$var$_didIteratorError = false, $95251e8ba9094fc2$var$_iteratorError = undefined;
    try {
        var $95251e8ba9094fc2$var$_loop = function() {
            var serviceButton = $95251e8ba9094fc2$var$_step.value;
            //toggle the information panel as needed
            serviceButton.addEventListener("click", function(event) {
                if (event.target.matches('[data-action="toggle-service-information"]') == true) event.target.closest(".service-button").setAttribute("data-show-service-information", serviceButton.dataset.showServiceInformation == "no" ? "yes" : "no");
            });
            //
            serviceButton.querySelector('button[data-action="get-total-landlord-insurance-service-token"]').addEventListener("click", function() {
                var _ref = (0, $7K4bb._)(function(event) {
                    var _ref, status, response, serviceButtonButtonContainer, _response_message;
                    return (0, $cX5iq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                //
                                if (event.target.disabled == true) return [
                                    2,
                                    false
                                ];
                                //
                                event.target.disabled = true;
                                //
                                serviceButton.classList.add("service-button-loading");
                                serviceButton.classList.remove("service-button-error");
                                //
                                event.target.setAttribute("data-loading", "data-loading");
                                return [
                                    4,
                                    $95251e8ba9094fc2$var$zenoFetch("post", "/api/get-total-landlord-insurance-service-token")
                                ];
                            case 1:
                                _ref = (0, $haqKc._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), status = _ref[0], response = _ref[1];
                                //
                                if (status == "success") {
                                    window.location = response.redirectTo;
                                    return [
                                        2
                                    ];
                                }
                                //
                                event.target.disabled = false;
                                //
                                serviceButton.classList.remove("service-button-loading");
                                serviceButton.classList.add("service-button-error");
                                //
                                event.target.removeAttribute("data-loading");
                                //add an error message to the widget
                                serviceButtonButtonContainer = serviceButton.querySelector(".service-button-button");
                                serviceButtonButtonContainer.insertAdjacentElement("beforeend", $95251e8ba9094fc2$var$createElement("p", {}, (_response_message = response.message) !== null && _response_message !== void 0 ? _response_message : "An unknown error has occurred."));
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }());
        };
        //
        for(var $95251e8ba9094fc2$var$_iterator = $95251e8ba9094fc2$var$serviceButtons[Symbol.iterator](), $95251e8ba9094fc2$var$_step; !($95251e8ba9094fc2$var$_iteratorNormalCompletion = ($95251e8ba9094fc2$var$_step = $95251e8ba9094fc2$var$_iterator.next()).done); $95251e8ba9094fc2$var$_iteratorNormalCompletion = true)$95251e8ba9094fc2$var$_loop();
    } catch (err) {
        $95251e8ba9094fc2$var$_didIteratorError = true;
        $95251e8ba9094fc2$var$_iteratorError = err;
    } finally{
        try {
            if (!$95251e8ba9094fc2$var$_iteratorNormalCompletion && $95251e8ba9094fc2$var$_iterator.return != null) {
                $95251e8ba9094fc2$var$_iterator.return();
            }
        } finally{
            if ($95251e8ba9094fc2$var$_didIteratorError) {
                throw $95251e8ba9094fc2$var$_iteratorError;
            }
        }
    }
}


document.querySelectorAll(".star-rating-box .stars").forEach(function(container) {
    var _loop = function(i) {
        //
        var element = container.querySelectorAll(".star")[i];
        //update the stars so the the "currently hovered" star (and all the siblings on the left) show as fille d- regardless of the true value
        element.addEventListener("mouseenter", function() {
            updateFilledStars(i);
        });
        //update the value of the hidden field
        element.addEventListener("click", function() {
            container.querySelector("input").value = i + 1;
        });
    };
    //
    var input = container.querySelector("input");
    //create a function to update the filled stars
    var updateFilledStars = function(numberOfStarsToFill) {
        container.querySelectorAll(".star").forEach(function(star, index) {
            star.classList.toggle("filled", index <= numberOfStarsToFill);
        });
    };
    //
    updateFilledStars(parseInt(input.value, 10) - 1);
    //when we leave the container reset the filled stars to the current value
    container.addEventListener("mouseleave", function(event) {
        updateFilledStars(input.value - 1);
    });
    //add interactions to each star
    for(var i = 0; i < container.querySelectorAll(".star").length; i++)_loop(i);
});


//------------------------------------------------------------------------------
var $7623fc06337d4a67$var$conditionalTests = {
    "equals": function(answers, expected) {
        return answers.includes(expected);
    },
    "notequals": function(answers, expected) {
        return !answers.includes(expected);
    }
};
var $7623fc06337d4a67$var$conditionalActions = {
    "visibility": function(action, question, inverted) {
        question.toggleAttribute("hidden", !inverted);
    }
};
//------------------------------------------------------------------------------
//
var $7623fc06337d4a67$var$surveys = document.querySelectorAll("form.survey");
var $7623fc06337d4a67$var$_iteratorNormalCompletion = true, $7623fc06337d4a67$var$_didIteratorError = false, $7623fc06337d4a67$var$_iteratorError = undefined;
try {
    var $7623fc06337d4a67$var$_loop = function() {
        var survey = $7623fc06337d4a67$var$_step.value;
        //
        var surveyRules = JSON.parse(survey.dataset.surveyLogic);
        if (typeof surveyRules == "object" && surveyRules !== null) {
            //
            survey.addEventListener("change", function(event) {
                $7623fc06337d4a67$var$updateSurveyState(survey, surveyRules);
            });
            $7623fc06337d4a67$var$updateSurveyState(survey, surveyRules);
        }
    };
    for(var $7623fc06337d4a67$var$_iterator = $7623fc06337d4a67$var$surveys[Symbol.iterator](), $7623fc06337d4a67$var$_step; !($7623fc06337d4a67$var$_iteratorNormalCompletion = ($7623fc06337d4a67$var$_step = $7623fc06337d4a67$var$_iterator.next()).done); $7623fc06337d4a67$var$_iteratorNormalCompletion = true)$7623fc06337d4a67$var$_loop();
} catch (err) {
    $7623fc06337d4a67$var$_didIteratorError = true;
    $7623fc06337d4a67$var$_iteratorError = err;
} finally{
    try {
        if (!$7623fc06337d4a67$var$_iteratorNormalCompletion && $7623fc06337d4a67$var$_iterator.return != null) {
            $7623fc06337d4a67$var$_iterator.return();
        }
    } finally{
        if ($7623fc06337d4a67$var$_didIteratorError) {
            throw $7623fc06337d4a67$var$_iteratorError;
        }
    }
}
//------------------------------------------------------------------------------
/**
 * [updateSurveyState description]
 * @param  {[type]} form  [description]
 * @param  {[type]} rules [description]
 * @return {[type]}       [description]
 */ function $7623fc06337d4a67$var$updateSurveyState(survey, rules) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rule = _step.value;
            $7623fc06337d4a67$var$doActions(survey, $7623fc06337d4a67$var$doTests(survey, rule.tests[0], rule.tests[1]), rule.actions);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * [doTests description]
 * @param  {[type]} mode  [description]
 * @param  {[type]} tests [description]
 * @return {[type]}       [description]
 */ function $7623fc06337d4a67$var$doTests(survey, mode, tests) {
    //
    var results = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        //
        for(var _iterator = tests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var test = _step.value;
            var question = survey.querySelector('.survey-question[data-question-id="' + test[0] + '"]');
            if (question) {
                var answers = $7623fc06337d4a67$var$getQuestionAnswers(question);
                if (test[1] in $7623fc06337d4a67$var$conditionalTests) results.push($7623fc06337d4a67$var$conditionalTests[test[1]](answers, test[2]));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    //
    if (mode == "all") return results.every(function(v) {
        return v === true;
    });
    else return results.some(function(v) {
        return v === true;
    });
    //
    return false;
}
/**
 * [doActions description]
 * @param  {[type]} inverted [description]
 * @param  {[type]} actions  [description]
 * @return {[type]}          [description]
 */ function $7623fc06337d4a67$var$doActions(survey, inverted, actions) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var action = _step.value;
            console.log(action, inverted);
            var question = survey.querySelector('.survey-question[data-question-id="' + action[0] + '"]');
            if (question) {
                if (action[1] in $7623fc06337d4a67$var$conditionalActions) $7623fc06337d4a67$var$conditionalActions[action[1]](action[2], question, inverted);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Get the answers for a question as an array of values
 * @param  element question
 * @return array
 */ function $7623fc06337d4a67$var$getQuestionAnswers(question) {
    //get all the inputs by the name attribute (throw an error if it's not found)
    var inputs = question.querySelectorAll("input, select, textarea");
    //create an array to store the results (we may be dealing with a multiple choice input)
    var inputValues = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        //
        for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            //
            var inputType = input.getAttribute("type") || input.tagName;
            //select - both single and multi selects
            if (inputType === "select") {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = input.querySelectorAll("option:selected")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var selectedOption = _step1.value;
                        inputValues.push(selectedOption.value);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                continue;
            }
            //process the input if it's a "radio button" or "checkbox"
            if (inputType === "radio" || inputType === "checkbox") {
                if (input.checked === true) inputValues.push(input.value);
                continue;
            }
            //everything else - make sure to trim it while we are at it
            inputValues.push(String(input.value).trim() == "" ? undefined : String(input.value).trim());
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    //filter out any undefined or null values
    inputValues = inputValues.filter(function(value) {
        return !(typeof value === "undefined" || value === null);
    });
    //
    return inputValues;
}
//------------------------------------------------------------------------------
//toggle the "question information" block if it's included on a question
var $7623fc06337d4a67$var$toggleQuestionInformationIcons = document.querySelectorAll('i[data-action="toggle-question-information"]');
var $7623fc06337d4a67$var$_iteratorNormalCompletion1 = true, $7623fc06337d4a67$var$_didIteratorError1 = false, $7623fc06337d4a67$var$_iteratorError1 = undefined;
try {
    var $7623fc06337d4a67$var$_loop1 = function() {
        var toggleQuestionInformationIcon = $7623fc06337d4a67$var$_step1.value;
        //
        toggleQuestionInformationIcon.addEventListener("click", function(event) {
            //
            event.preventDefault();
            //
            var additionalContentPanel = toggleQuestionInformationIcon.closest(".survey-question").querySelector(".question-information");
            additionalContentPanel.dispatchEvent(new Event("toggle"));
        });
    };
    for(var $7623fc06337d4a67$var$_iterator1 = $7623fc06337d4a67$var$toggleQuestionInformationIcons[Symbol.iterator](), $7623fc06337d4a67$var$_step1; !($7623fc06337d4a67$var$_iteratorNormalCompletion1 = ($7623fc06337d4a67$var$_step1 = $7623fc06337d4a67$var$_iterator1.next()).done); $7623fc06337d4a67$var$_iteratorNormalCompletion1 = true)$7623fc06337d4a67$var$_loop1();
     //------------------------------------------------------------------------------
} catch (err) {
    $7623fc06337d4a67$var$_didIteratorError1 = true;
    $7623fc06337d4a67$var$_iteratorError1 = err;
} finally{
    try {
        if (!$7623fc06337d4a67$var$_iteratorNormalCompletion1 && $7623fc06337d4a67$var$_iterator1.return != null) {
            $7623fc06337d4a67$var$_iterator1.return();
        }
    } finally{
        if ($7623fc06337d4a67$var$_didIteratorError1) {
            throw $7623fc06337d4a67$var$_iteratorError1;
        }
    }
}


//
var $23ac1d3c1e782bdf$var$tabComponents = document.querySelectorAll(".tabs");
var $23ac1d3c1e782bdf$var$_iteratorNormalCompletion = true, $23ac1d3c1e782bdf$var$_didIteratorError = false, $23ac1d3c1e782bdf$var$_iteratorError = undefined;
//
if ($23ac1d3c1e782bdf$var$tabComponents !== null) try {
    var $23ac1d3c1e782bdf$var$_loop = function() {
        var tabComponent = $23ac1d3c1e782bdf$var$_step.value;
        var tabs = tabComponent.querySelectorAll(".tab-label");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (tabs !== null) try {
            var _loop = function() {
                var thisTab = _step1.value;
                thisTab.addEventListener("click", function(event) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = tabs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var otherTab = _step.value;
                            otherTab.removeAttribute("data-open");
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    thisTab.setAttribute("data-open", "data-open");
                });
            };
            for(var _iterator = tabs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    for(var $23ac1d3c1e782bdf$var$_iterator = $23ac1d3c1e782bdf$var$tabComponents[Symbol.iterator](), $23ac1d3c1e782bdf$var$_step; !($23ac1d3c1e782bdf$var$_iteratorNormalCompletion = ($23ac1d3c1e782bdf$var$_step = $23ac1d3c1e782bdf$var$_iterator.next()).done); $23ac1d3c1e782bdf$var$_iteratorNormalCompletion = true)$23ac1d3c1e782bdf$var$_loop();
} catch (err) {
    $23ac1d3c1e782bdf$var$_didIteratorError = true;
    $23ac1d3c1e782bdf$var$_iteratorError = err;
} finally{
    try {
        if (!$23ac1d3c1e782bdf$var$_iteratorNormalCompletion && $23ac1d3c1e782bdf$var$_iterator.return != null) {
            $23ac1d3c1e782bdf$var$_iterator.return();
        }
    } finally{
        if ($23ac1d3c1e782bdf$var$_didIteratorError) {
            throw $23ac1d3c1e782bdf$var$_iteratorError;
        }
    }
}


parcelRequire("eHUQL");
var $c15365d7bbd73840$exports = {};
//
var $c15365d7bbd73840$var$_this = $c15365d7bbd73840$exports;
var $c15365d7bbd73840$var$trainingBookingPanel = document.querySelector(".training-booking-panel-dates");
//
if ($c15365d7bbd73840$var$trainingBookingPanel != null) {
    //
    var $c15365d7bbd73840$var$showAvailableDatesToggle = $c15365d7bbd73840$var$trainingBookingPanel.querySelector('.toggle-switch[data-action="showAvailableDates"] input');
    //handle the show/hide available dates toggle
    var $c15365d7bbd73840$var$toggleAvailableDates = function() {
        //
        var isChecked = $c15365d7bbd73840$var$showAvailableDatesToggle.checked;
        var selectedMethods = [];
        //
        $c15365d7bbd73840$var$trainingBookingPanel.querySelectorAll(".filter.selected").forEach(function(button) {
            var method = button.getAttribute("data-action").replace("Toggle", "");
            selectedMethods.push(method);
        });
        //
        if (selectedMethods.length === 0) selectedMethods.push("eLearning", "eClassroom", "Classroom");
        //
        $c15365d7bbd73840$var$trainingBookingPanel.querySelectorAll(".training-date").forEach(function(element) {
            //
            var method = element.getAttribute("data-deliveryMethod");
            //
            var placesAvailable = parseInt(element.getAttribute("data-placesavailable"));
            //
            if (isNaN(placesAvailable)) placesAvailable = 0;
            //only apply filtering to the selected methods
            if (selectedMethods.includes(method)) {
                if (isChecked && placesAvailable <= 0) element.style.display = "none";
                else element.style.display = "flex";
            }
        });
    };
    //event listener for the toggle checkbox
    if ($c15365d7bbd73840$var$showAvailableDatesToggle) {
        $c15365d7bbd73840$var$showAvailableDatesToggle.addEventListener("change", $c15365d7bbd73840$var$toggleAvailableDates);
        $c15365d7bbd73840$var$toggleAvailableDates();
    }
    //
    var $c15365d7bbd73840$var$eLearningState = {
        name: "eLearning",
        button: $c15365d7bbd73840$var$trainingBookingPanel.querySelector('.filter[data-action="eLearningToggle"]:not(:disabled)'),
        state: false
    };
    var $c15365d7bbd73840$var$eClassroomState = {
        name: "eClassroom",
        button: $c15365d7bbd73840$var$trainingBookingPanel.querySelector('.filter[data-action="eClassroomToggle"]:not(:disabled)'),
        state: false
    };
    var $c15365d7bbd73840$var$classroomState = {
        name: "Classroom",
        button: $c15365d7bbd73840$var$trainingBookingPanel.querySelector('.filter[data-action="ClassroomToggle"]:not(:disabled)'),
        state: false
    };
    //
    if ($c15365d7bbd73840$var$eLearningState && $c15365d7bbd73840$var$eClassroomState && $c15365d7bbd73840$var$classroomState) {
        var $c15365d7bbd73840$var$toggleState = //
        function toggleState(deliveryMethodState) {
            //
            var currentlyShowing = $c15365d7bbd73840$var$deliveryMethods.reduce(function(accumulated, value) {
                return value.state ? accumulated + 1 : accumulated;
            }, 0);
            //
            if (deliveryMethodState.state == false || currentlyShowing > 1) deliveryMethodState.state = !deliveryMethodState.state;
            //
            $c15365d7bbd73840$var$deliveryMethods.forEach(function(deliveryMethod) {
                if (deliveryMethod.state == true) {
                    deliveryMethod.button.classList.add("selected");
                    $c15365d7bbd73840$var$trainingBookingPanel.querySelectorAll('.training-date[data-deliveryMethod="' + deliveryMethod.name + '"]').forEach(function(element) {
                        return element.style.display = "flex";
                    });
                } else {
                    deliveryMethod.button.classList.remove("selected");
                    $c15365d7bbd73840$var$trainingBookingPanel.querySelectorAll('.training-date[data-deliveryMethod="' + deliveryMethod.name + '"]').forEach(function(element) {
                        return element.style.display = "none";
                    });
                }
            });
            //call to filter available dates based on current selections
            $c15365d7bbd73840$var$toggleAvailableDates();
        };
        //
        var $c15365d7bbd73840$var$deliveryMethods = [
            $c15365d7bbd73840$var$eLearningState,
            $c15365d7bbd73840$var$eClassroomState,
            $c15365d7bbd73840$var$classroomState
        ];
        $c15365d7bbd73840$var$deliveryMethods = $c15365d7bbd73840$var$deliveryMethods.filter(function(deliveryMethod) {
            return !(deliveryMethod.button === null);
        });
        //
        $c15365d7bbd73840$var$deliveryMethods.forEach(function(deliveryMethod) {
            deliveryMethod.button.addEventListener("click", $c15365d7bbd73840$var$toggleState.bind($c15365d7bbd73840$var$_this, deliveryMethod));
        });
    }
}


parcelRequire("bZLPO");
//

var $4j8k4 = parcelRequire("4j8k4");

var $bYFju = parcelRequire("bYFju");
function $e04aee34a085cd1a$export$c2c98ac76e997b63(o, p) {
    $e04aee34a085cd1a$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e04aee34a085cd1a$export$c2c98ac76e997b63(o, p);
}


function $153fd60b2c333935$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $e04aee34a085cd1a$export$c2c98ac76e997b63)(subClass, superClass);
}


function $af7c50e2271e721b$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $98a1ceb3face8dc3$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $af7c50e2271e721b$export$685354647fba1516)()) $98a1ceb3face8dc3$export$2d841144c5f8c4ab = Reflect.construct;
    else $98a1ceb3face8dc3$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $e04aee34a085cd1a$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $98a1ceb3face8dc3$export$2d841144c5f8c4ab.apply(null, arguments);
}


function $110522e61abe8a22$export$f09211a7d3c496a1(o) {
    $110522e61abe8a22$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $110522e61abe8a22$export$f09211a7d3c496a1(o);
}


function $1315fce2caa01298$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $bbb288d66f46c3fb$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bbb288d66f46c3fb$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $1315fce2caa01298$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $98a1ceb3face8dc3$export$2d841144c5f8c4ab)(Class, arguments, (0, $110522e61abe8a22$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $e04aee34a085cd1a$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $bbb288d66f46c3fb$export$2466d533fda16e33(Class);
}




function $13ca6993d5290b30$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $h9OH6 = parcelRequire("h9OH6");
function $243b2d1e8a5df303$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $h9OH6._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $13ca6993d5290b30$export$f3b8ed2e4a5d10b8)(self);
}


function $8619e245adad4f80$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $af7c50e2271e721b$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $110522e61abe8a22$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $110522e61abe8a22$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $243b2d1e8a5df303$export$ef97c660ca164e52)(this, result);
    };
}


customElements.define("table-quick-search", /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $153fd60b2c333935$export$7e4530ad35d3bb8)(_class, HTMLElement1);
    var _super = (0, $8619e245adad4f80$export$8dd05c13f5255580)(_class);
    function _class() {
        (0, $4j8k4._)(this, _class);
        return _super.call(this);
    }
    (0, $bYFju._)(_class, [
        {
            //
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                //
                var template = document.createElement("template");
                template.innerHTML = '\n            <style>\n                :host { position: relative; isolation: isolate; }\n                .search-input-wrapper { position: relative; text-align: right; z-index: 100; }\n                .search-input-wrapper .search-input { padding: 0.5em; }\n                .search-input-wrapper .search-input.absolute { position: absolute; right: 0; }\n                .no-results { font-weight: bold; text-align: center; }\n            </style>\n            <div class="search-input-wrapper">\n                <input type="text" class="search-input" placeholder="Enter your search term...">\n            </div>\n            <slot></slot>\n            <div class="no-results" style="display: none;">No results found</div>\n        ';
                //create the shadow root
                this._shadowRoot = this.attachShadow({
                    "mode": "closed"
                });
                this._shadowRoot.appendChild(template.content.cloneNode(true));
                //if the first item in the light-dom is not a table - the assume we have a title - so position the search absolutely
                if (!this.firstElementChild.matches("table")) this._shadowRoot.querySelector(".search-input").classList.add("absolute");
                //get the input element
                var input = this._shadowRoot.querySelector(".search-input");
                //get the message element for displaying no results
                var noResults = this._shadowRoot.querySelector(".no-results");
                //add event listener for the input keyup event
                input.addEventListener("input", function() {
                    //
                    var searchTerm = input.value.toLowerCase();
                    //
                    var matchFound = false;
                    // Loop through all table rows, hide the ones that don't match the search term
                    _this.querySelectorAll("table tbody tr").forEach(function(row) {
                        //
                        var rowVisible = false;
                        //
                        var cellContents = Array.from(row.querySelectorAll("th, td")).reduce(function(a, c) {
                            return a + " " + c.textContent.toLowerCase();
                        }, "");
                        //
                        if (cellContents.includes(searchTerm)) {
                            rowVisible = true;
                            matchFound = true;
                        }
                        //
                        row.style.display = rowVisible ? "table-row" : "none";
                    });
                    // Show/hide the no results message based on matchFound
                    noResults.style.display = matchFound ? "none" : "block";
                });
            }
        }
    ]);
    return _class;
}((0, $bbb288d66f46c3fb$export$2466d533fda16e33)(HTMLElement)));



})();
//# sourceMappingURL=main.min.js.map
